var items = {
  "block.minecraft.acacia_button": "Akasiaknapp",
  "block.minecraft.acacia_door": "Acasiadörer",
  "block.minecraft.acacia_fence": "Akasiastakiet",
  "block.minecraft.acacia_fence_gate": "Grind i akasiastakiet",
  "block.minecraft.acacia_hanging_sign": "Hängande akaciaskylt",
  "block.minecraft.acacia_leaves": "Akasialov",
  "block.minecraft.acacia_log": "Akasiakabb",
  "block.minecraft.acacia_planks": "Akasiaplaunkur",
  "block.minecraft.acacia_pressure_plate": "Akasiapressplatt",
  "block.minecraft.acacia_sapling": "Acasiaplemta",
  "block.minecraft.acacia_shelf": "Akaciahylla",
  "block.minecraft.acacia_sign": "Akasiastjylt",
  "block.minecraft.acacia_slab": "Akasiastjiv",
  "block.minecraft.acacia_stairs": "Akasiatrampur",
  "block.minecraft.acacia_trapdoor": "Akasiafollukku",
  "block.minecraft.acacia_wall_hanging_sign": "Hängande akaciaskylt på vägg",
  "block.minecraft.acacia_wall_sign": "Akasiaweggstjylt",
  "block.minecraft.acacia_wood": "Acasiawiðn",
  "block.minecraft.activator_rail": "Rels min aktivator",
  "block.minecraft.air": "Weðrę",
  "block.minecraft.allium": "Graslok",
  "block.minecraft.amethyst_block": "Ametistblokk",
  "block.minecraft.amethyst_cluster": "Ametistuop",
  "block.minecraft.ancient_debris": "Ljuotgåmålt rappel",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Andesitstjiv",
  "block.minecraft.andesite_stairs": "Andesittrampur",
  "block.minecraft.andesite_wall": "Andesitwegg",
  "block.minecraft.anvil": "Smiðsteð",
  "block.minecraft.attached_melon_stem": "Ą̊sett melonstiuok",
  "block.minecraft.attached_pumpkin_stem": "Påklistrað pumpstiuok",
  "block.minecraft.azalea": "Asalea",
  "block.minecraft.azalea_leaves": "Asalealover",
  "block.minecraft.azure_bluet": "Poslinsbliuomme",
  "block.minecraft.bamboo": "Bambu",
  "block.minecraft.bamboo_block": "Bambublock",
  "block.minecraft.bamboo_button": "Bambuknapp",
  "block.minecraft.bamboo_door": "Bambudörr",
  "block.minecraft.bamboo_fence": "Bambustaket",
  "block.minecraft.bamboo_fence_gate": "Bambugrind",
  "block.minecraft.bamboo_hanging_sign": "Hängande bambuskylt",
  "block.minecraft.bamboo_mosaic": "Bambumosaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambumosaikplatta",
  "block.minecraft.bamboo_mosaic_stairs": "Bambumosaiktrappa",
  "block.minecraft.bamboo_planks": "Bambuplankor",
  "block.minecraft.bamboo_pressure_plate": "Bambutryckplatta",
  "block.minecraft.bamboo_sapling": "Bambunylaðir",
  "block.minecraft.bamboo_shelf": "Bambuhylla",
  "block.minecraft.bamboo_sign": "Bambuskylt",
  "block.minecraft.bamboo_slab": "Bambuplatta",
  "block.minecraft.bamboo_stairs": "Bambutrappa",
  "block.minecraft.bamboo_trapdoor": "Bambufallucka",
  "block.minecraft.bamboo_wall_hanging_sign": "Hängande bambuskylt på vägg",
  "block.minecraft.bamboo_wall_sign": "Bambuskylt på vägg",
  "block.minecraft.banner.base.black": "Ielswart områð",
  "block.minecraft.banner.base.blue": "Ielblått umråð",
  "block.minecraft.banner.base.brown": "Ielbrunt områð",
  "block.minecraft.banner.base.cyan": "Ielsyanfergað områd",
  "block.minecraft.banner.base.gray": "Ielgrå´tt umråð",
  "block.minecraft.banner.base.green": "Ielgryönt områð",
  "block.minecraft.banner.base.light_blue": "Ielt liuosdblå´tt umdråð",
  "block.minecraft.banner.base.light_gray": "Ielt liuosgrått områð",
  "block.minecraft.banner.base.lime": "Ielt laimfergað umråð",
  "block.minecraft.banner.base.magenta": "Ielt magentafergað umråð",
  "block.minecraft.banner.base.orange": "Ielt guolro´tt umråð",
  "block.minecraft.banner.base.pink": "Ielstjärt umråð",
  "block.minecraft.banner.base.purple": "Iellila områð",
  "block.minecraft.banner.base.red": "Ielrot områð",
  "block.minecraft.banner.base.white": "Ielwai´tt umråð",
  "block.minecraft.banner.base.yellow": "Ielguolt områð",
  "block.minecraft.banner.border.black": "Swart inrazmningg",
  "block.minecraft.banner.border.blue": "Blå inramningg",
  "block.minecraft.banner.border.brown": "Brun inramningg",
  "block.minecraft.banner.border.cyan": "Syanfergað inramningg",
  "block.minecraft.banner.border.gray": "Grå inramningg",
  "block.minecraft.banner.border.green": "Gryön inramningg",
  "block.minecraft.banner.border.light_blue": "Ljuosblå inramningg",
  "block.minecraft.banner.border.light_gray": "Liuosgrå inramningg",
  "block.minecraft.banner.border.lime": "Laimgryönfergað inramningg",
  "block.minecraft.banner.border.magenta": "Magenta inramningg",
  "block.minecraft.banner.border.orange": "Guolroð inramningg",
  "block.minecraft.banner.border.pink": "Stjär inramningg",
  "block.minecraft.banner.border.purple": "Lila inramningg",
  "block.minecraft.banner.border.red": "Roð inramningg",
  "block.minecraft.banner.border.white": "Wait inramningg",
  "block.minecraft.banner.border.yellow": "Guol inramningg",
  "block.minecraft.banner.bricks.black": "Swart tigelmömster",
  "block.minecraft.banner.bricks.blue": "Blått tigelmömster",
  "block.minecraft.banner.bricks.brown": "Brunt tigelmömster",
  "block.minecraft.banner.bricks.cyan": "Syanfergað tigelmömster",
  "block.minecraft.banner.bricks.gray": "Grå tigelmömster",
  "block.minecraft.banner.bricks.green": "Gryönt tigelmömster",
  "block.minecraft.banner.bricks.light_blue": "Ljuosblått tigelmömster",
  "block.minecraft.banner.bricks.light_gray": "Ljuosgrå tigelmömster",
  "block.minecraft.banner.bricks.lime": "Laimfergað tigelmömster",
  "block.minecraft.banner.bricks.magenta": "Magenta tigelmömster",
  "block.minecraft.banner.bricks.orange": "Guolrott tigelmömster",
  "block.minecraft.banner.bricks.pink": "Stjärt tigelmömster",
  "block.minecraft.banner.bricks.purple": "Lila tigelmömster",
  "block.minecraft.banner.bricks.red": "Rott tigelmömster",
  "block.minecraft.banner.bricks.white": "Waitt tigelmömster",
  "block.minecraft.banner.bricks.yellow": "Guolt tigelmömster",
  "block.minecraft.banner.circle.black": "Swart krindjel",
  "block.minecraft.banner.circle.blue": "Blå krindjel",
  "block.minecraft.banner.circle.brown": "Brun Krindjel",
  "block.minecraft.banner.circle.cyan": "Syanfergað krindjel",
  "block.minecraft.banner.circle.gray": "Grå krindjel",
  "block.minecraft.banner.circle.green": "Gryön krindjel",
  "block.minecraft.banner.circle.light_blue": "Ljuosblå krindjel",
  "block.minecraft.banner.circle.light_gray": "Ljuosgrå krindjel",
  "block.minecraft.banner.circle.lime": "Laimgryönfergað krindjel",
  "block.minecraft.banner.circle.magenta": "Magenta krindjel",
  "block.minecraft.banner.circle.orange": "Guolroð krindjel",
  "block.minecraft.banner.circle.pink": "Stjär krindjel",
  "block.minecraft.banner.circle.purple": "Lila krindjel",
  "block.minecraft.banner.circle.red": "Roð krindjel",
  "block.minecraft.banner.circle.white": "Wait krindjel",
  "block.minecraft.banner.circle.yellow": "Guol krindjel",
  "block.minecraft.banner.creeper.black": "Swart creeper-leðning",
  "block.minecraft.banner.creeper.blue": "Blå creeper-leðningg",
  "block.minecraft.banner.creeper.brown": "Brun creeper-leðningg",
  "block.minecraft.banner.creeper.cyan": "Cyanfergað creeper-leðningg",
  "block.minecraft.banner.creeper.gray": "Grå creeper-leðningg",
  "block.minecraft.banner.creeper.green": "Gryön creeper-leðningg",
  "block.minecraft.banner.creeper.light_blue": "Ljuosblå creeper-leðningg",
  "block.minecraft.banner.creeper.light_gray": "Ljuosgrå creeper-leðningg",
  "block.minecraft.banner.creeper.lime": "Laimgryönfergað creeper-leðningg",
  "block.minecraft.banner.creeper.magenta": "Magenta creeper-leðningg",
  "block.minecraft.banner.creeper.orange": "Guolroð creeper-leðningg",
  "block.minecraft.banner.creeper.pink": "Stjär creeper-leðningg",
  "block.minecraft.banner.creeper.purple": "Lila creeper-leðningg",
  "block.minecraft.banner.creeper.red": "Roð creeper-leðningg",
  "block.minecraft.banner.creeper.white": "Wait creeper-leðningg",
  "block.minecraft.banner.creeper.yellow": "Guol creeper-leðningg",
  "block.minecraft.banner.cross.black": "Swartkross",
  "block.minecraft.banner.cross.blue": "Blåkross",
  "block.minecraft.banner.cross.brown": "Brunkross",
  "block.minecraft.banner.cross.cyan": "Syanfergaðkross",
  "block.minecraft.banner.cross.gray": "Grått kross",
  "block.minecraft.banner.cross.green": "Gryönkross",
  "block.minecraft.banner.cross.light_blue": "Ljusblått kross",
  "block.minecraft.banner.cross.light_gray": "Ljuosgrått kross",
  "block.minecraft.banner.cross.lime": "Laimfergaðkross",
  "block.minecraft.banner.cross.magenta": "Magentakross",
  "block.minecraft.banner.cross.orange": "Guolrott kross",
  "block.minecraft.banner.cross.pink": "Sjtärt kross",
  "block.minecraft.banner.cross.purple": "Lilakross",
  "block.minecraft.banner.cross.red": "Roðkross",
  "block.minecraft.banner.cross.white": "Waitkross",
  "block.minecraft.banner.cross.yellow": "Guolt kross",
  "block.minecraft.banner.curly_border.black": "Swart taggun inramningg",
  "block.minecraft.banner.curly_border.blue": "Blå taggun inramningg",
  "block.minecraft.banner.curly_border.brown": "Brun taggun inramningg",
  "block.minecraft.banner.curly_border.cyan": "Syanfergað taggun inramningg",
  "block.minecraft.banner.curly_border.gray": "Grå taggun inramningg",
  "block.minecraft.banner.curly_border.green": "Gryön taggun inramningg",
  "block.minecraft.banner.curly_border.light_blue": "Ljuosblå taggun inramningg",
  "block.minecraft.banner.curly_border.light_gray": "Ljuosgrå taggun inramningg",
  "block.minecraft.banner.curly_border.lime": "Laimgryönfergað taggun inramningg",
  "block.minecraft.banner.curly_border.magenta": "Magenta taggun inramningg",
  "block.minecraft.banner.curly_border.orange": "Guolroð taggun inramningg",
  "block.minecraft.banner.curly_border.pink": "Stjär taggun inramningg",
  "block.minecraft.banner.curly_border.purple": "Lila taggun inramningg",
  "block.minecraft.banner.curly_border.red": "Roð taggun inramningg",
  "block.minecraft.banner.curly_border.white": "Wait taggun inramningg",
  "block.minecraft.banner.curly_border.yellow": "Guol taggun inramningg",
  "block.minecraft.banner.diagonal_left.black": "Swart avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.blue": "Blått avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.brown": "Brunt avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.cyan": "Syanfergað avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.gray": "Grått avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.green": "Gryönt avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.light_blue": "Ljuosblått avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.light_gray": "Ljuosgrå avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.lime": "Laimgryönfergað avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.orange": "Guolrott avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.pink": "Stjärt avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.purple": "Lila avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.red": "Ro'tt avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.white": "Waitt avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_left.yellow": "Guolt avut kroppstrik uvoni að wįster",
  "block.minecraft.banner.diagonal_right.black": "Swart trianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.blue": "Blåtrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.brown": "Bruntrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.cyan": "Syanfergadtrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.gray": "Gråtrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.green": "Gryöntrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.light_blue": "Liuosblåtrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.light_gray": "Ljuosgrå trianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.lime": "Laimfergaðtrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.magenta": "Magentatrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.orange": "Guolroðtrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.pink": "Stjärtrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.purple": "Lilatrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.red": "Roðtrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.white": "Waittrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_right.yellow": "Guoltrianggel uvoni að yöger",
  "block.minecraft.banner.diagonal_up_left.black": "Swart underåva",
  "block.minecraft.banner.diagonal_up_left.blue": "Blå underåva",
  "block.minecraft.banner.diagonal_up_left.brown": "Brun underåva",
  "block.minecraft.banner.diagonal_up_left.cyan": "Syanfergað underåva",
  "block.minecraft.banner.diagonal_up_left.gray": "Grå underåva",
  "block.minecraft.banner.diagonal_up_left.green": "Gryön underåva",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Liuosblå underåva",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Liuosgrå underåva",
  "block.minecraft.banner.diagonal_up_left.lime": "Laimgryönfergað underåva",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta underåva",
  "block.minecraft.banner.diagonal_up_left.orange": "Guolroð underåva",
  "block.minecraft.banner.diagonal_up_left.pink": "Stjär underåva",
  "block.minecraft.banner.diagonal_up_left.purple": "Lila underåva",
  "block.minecraft.banner.diagonal_up_left.red": "Roð underåva",
  "block.minecraft.banner.diagonal_up_left.white": "Wait underåva",
  "block.minecraft.banner.diagonal_up_left.yellow": "Guol underåva",
  "block.minecraft.banner.diagonal_up_right.black": "Swart underåva",
  "block.minecraft.banner.diagonal_up_right.blue": "Blå underåva",
  "block.minecraft.banner.diagonal_up_right.brown": "Brun underåva",
  "block.minecraft.banner.diagonal_up_right.cyan": "Syanfergad underåva",
  "block.minecraft.banner.diagonal_up_right.gray": "Grå underåva",
  "block.minecraft.banner.diagonal_up_right.green": "Gryön underåva",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Ljuosblå underåva",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ljuosgrå underåva",
  "block.minecraft.banner.diagonal_up_right.lime": "Laimgryönfergad underåva",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta underåva",
  "block.minecraft.banner.diagonal_up_right.orange": "Guolroð underåva",
  "block.minecraft.banner.diagonal_up_right.pink": "Stjär underåva",
  "block.minecraft.banner.diagonal_up_right.purple": "Lila underåva",
  "block.minecraft.banner.diagonal_up_right.red": "Rod underåva",
  "block.minecraft.banner.diagonal_up_right.white": "Wait underåva",
  "block.minecraft.banner.diagonal_up_right.yellow": "Guol underåva",
  "block.minecraft.banner.flow.black": "Svart virvel",
  "block.minecraft.banner.flow.blue": "Blå virvel",
  "block.minecraft.banner.flow.brown": "Brun virvel",
  "block.minecraft.banner.flow.cyan": "Turkos virvel",
  "block.minecraft.banner.flow.gray": "Grå virvel",
  "block.minecraft.banner.flow.green": "Grön virvel",
  "block.minecraft.banner.flow.light_blue": "Ljusblå virvel",
  "block.minecraft.banner.flow.light_gray": "Ljusgrå virvel",
  "block.minecraft.banner.flow.lime": "Limegrön virvel",
  "block.minecraft.banner.flow.magenta": "Ljuslila virvel",
  "block.minecraft.banner.flow.orange": "Orange virvel",
  "block.minecraft.banner.flow.pink": "Rosa virvel",
  "block.minecraft.banner.flow.purple": "Lila virvel",
  "block.minecraft.banner.flow.red": "Röd virvel",
  "block.minecraft.banner.flow.white": "Vit virvel",
  "block.minecraft.banner.flow.yellow": "Gul virvel",
  "block.minecraft.banner.flower.black": "Swart bljuomme",
  "block.minecraft.banner.flower.blue": "Blå bljuomme",
  "block.minecraft.banner.flower.brown": "Brun bljuomme",
  "block.minecraft.banner.flower.cyan": "Syanfergað bljuomme",
  "block.minecraft.banner.flower.gray": "Grå bljuomme",
  "block.minecraft.banner.flower.green": "Gryön bljuomme",
  "block.minecraft.banner.flower.light_blue": "Ljuosblå bljomme",
  "block.minecraft.banner.flower.light_gray": "Liuosgrå bljuomme",
  "block.minecraft.banner.flower.lime": "Laimgryönfergað bljomme",
  "block.minecraft.banner.flower.magenta": "Mageta bljomme",
  "block.minecraft.banner.flower.orange": "Guolroð bljomme",
  "block.minecraft.banner.flower.pink": "Stjär bljuomme",
  "block.minecraft.banner.flower.purple": "Lila bljuomme",
  "block.minecraft.banner.flower.red": "Roð bljuomme",
  "block.minecraft.banner.flower.white": "Wait bljomme",
  "block.minecraft.banner.flower.yellow": "Guol bljomme",
  "block.minecraft.banner.globe.black": "Swart krindjel",
  "block.minecraft.banner.globe.blue": "Blå krindjel",
  "block.minecraft.banner.globe.brown": "Brun krindjel",
  "block.minecraft.banner.globe.cyan": "Syanfergað krindjel",
  "block.minecraft.banner.globe.gray": "Grå krindjel",
  "block.minecraft.banner.globe.green": "Gryön krindjel",
  "block.minecraft.banner.globe.light_blue": "Ljuosblå krindjel",
  "block.minecraft.banner.globe.light_gray": "Liuosgrå krindjel",
  "block.minecraft.banner.globe.lime": "Laimfergað krindjel",
  "block.minecraft.banner.globe.magenta": "Magenta krindjel",
  "block.minecraft.banner.globe.orange": "Guolroð krindjel",
  "block.minecraft.banner.globe.pink": "Stjär krindjel",
  "block.minecraft.banner.globe.purple": "Lila krindjel",
  "block.minecraft.banner.globe.red": "Roð krindjel",
  "block.minecraft.banner.globe.white": "Wait krindjel",
  "block.minecraft.banner.globe.yellow": "Guol krindjel",
  "block.minecraft.banner.gradient.black": "Swart yvyrgangg uvoter",
  "block.minecraft.banner.gradient.blue": "Blå yvyrgangg uvoter",
  "block.minecraft.banner.gradient.brown": "Brun yvyrgangg uvoter",
  "block.minecraft.banner.gradient.cyan": "Syanfergad yvyrgangg uvoter",
  "block.minecraft.banner.gradient.gray": "Grå yvyrgangg uvoter",
  "block.minecraft.banner.gradient.green": "Gryön yvyrgangg uvoter",
  "block.minecraft.banner.gradient.light_blue": "Ljuosblå yvyrgangg uvǫter",
  "block.minecraft.banner.gradient.light_gray": "Ljuosgrå yvyrgangg uvoter",
  "block.minecraft.banner.gradient.lime": "Laimgryönfergað yvyrgangg uvǫter",
  "block.minecraft.banner.gradient.magenta": "Magenta yvyrgangg uvǫter",
  "block.minecraft.banner.gradient.orange": "Guolroð yvyrgangg uvǫter",
  "block.minecraft.banner.gradient.pink": "Stjär yvyrgangg uvǫter",
  "block.minecraft.banner.gradient.purple": "Lila yvyrgangg uvoter",
  "block.minecraft.banner.gradient.red": "Roð yvyrgangg uvoter",
  "block.minecraft.banner.gradient.white": "Wait yvyrgangg uvǫter",
  "block.minecraft.banner.gradient.yellow": "Guol yvyrgangg uvǫter",
  "block.minecraft.banner.gradient_up.black": "Swart yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.blue": "Blå yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.brown": "Brun yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.cyan": "Syanfergað yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.gray": "Grå yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.green": "Gryön yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.light_blue": "Liuosblå yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.light_gray": "Liuosgrå yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.lime": "Laimgryönfergad yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.magenta": "Magenta yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.orange": "Guolroð yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.pink": "Stjär yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.purple": "Lila yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.red": "Roð yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.white": "Wait yvyrgangg niðǫter",
  "block.minecraft.banner.gradient_up.yellow": "Guol yvyrgangg niðǫter",
  "block.minecraft.banner.guster.black": "Svart vindväsen",
  "block.minecraft.banner.guster.blue": "Blått vindväsen",
  "block.minecraft.banner.guster.brown": "Brunt vindväsen",
  "block.minecraft.banner.guster.cyan": "Turkost vindväsen",
  "block.minecraft.banner.guster.gray": "Grått vindväsen",
  "block.minecraft.banner.guster.green": "Grönt vindväsen",
  "block.minecraft.banner.guster.light_blue": "Ljusblått vindväsen",
  "block.minecraft.banner.guster.light_gray": "Ljusgrått vindväsen",
  "block.minecraft.banner.guster.lime": "Limegrönt vindväsen",
  "block.minecraft.banner.guster.magenta": "Ljuslila vindväsen",
  "block.minecraft.banner.guster.orange": "Orange vindväsen",
  "block.minecraft.banner.guster.pink": "Rosa vindväsen",
  "block.minecraft.banner.guster.purple": "Lila vindväsen",
  "block.minecraft.banner.guster.red": "Rött vindväsen",
  "block.minecraft.banner.guster.white": "Vitt vindväsen",
  "block.minecraft.banner.guster.yellow": "Gult vindväsen",
  "block.minecraft.banner.half_horizontal.black": "Swart uvoniåva",
  "block.minecraft.banner.half_horizontal.blue": "Blå uvoniåva",
  "block.minecraft.banner.half_horizontal.brown": "Brun uvoniåva",
  "block.minecraft.banner.half_horizontal.cyan": "Syanfergað uvoniåva",
  "block.minecraft.banner.half_horizontal.gray": "Grå uvoniåva",
  "block.minecraft.banner.half_horizontal.green": "Gryön uvoniåva",
  "block.minecraft.banner.half_horizontal.light_blue": "Ljuosblå uvoniåva",
  "block.minecraft.banner.half_horizontal.light_gray": "Liuosgrå uvoniåva",
  "block.minecraft.banner.half_horizontal.lime": "Laimgryönfergað uvoniåva",
  "block.minecraft.banner.half_horizontal.magenta": "Magentafergað uvoniåva",
  "block.minecraft.banner.half_horizontal.orange": "Guolroð uvoniåva",
  "block.minecraft.banner.half_horizontal.pink": "Laimfergað uvoniåva",
  "block.minecraft.banner.half_horizontal.purple": "Lila uvoniåva",
  "block.minecraft.banner.half_horizontal.red": "Roð uvoniåva",
  "block.minecraft.banner.half_horizontal.white": "Wait uvoniåva",
  "block.minecraft.banner.half_horizontal.yellow": "Guol uvoniåva",
  "block.minecraft.banner.half_horizontal_bottom.black": "Swart underåva",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blå underåva",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brun underåva",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Syanfergað underåva",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grå underåva",
  "block.minecraft.banner.half_horizontal_bottom.green": "Gryön underåva",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Ljuosblå underåva",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ljuosgrå underåva",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Laimfergað underåva",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magentafergað underåva",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Guolroð underåva",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Stjär underåva",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Lila underåva",
  "block.minecraft.banner.half_horizontal_bottom.red": "Roð underåva",
  "block.minecraft.banner.half_horizontal_bottom.white": "Waitt underåva",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Guol underåva",
  "block.minecraft.banner.half_vertical.black": "Swart wįsteråva",
  "block.minecraft.banner.half_vertical.blue": "Blå wįsteråva",
  "block.minecraft.banner.half_vertical.brown": "Brun wįsteråva",
  "block.minecraft.banner.half_vertical.cyan": "Syanfergað wįsteråva",
  "block.minecraft.banner.half_vertical.gray": "Grå wįsteråva",
  "block.minecraft.banner.half_vertical.green": "Gryön wįsteråva",
  "block.minecraft.banner.half_vertical.light_blue": "Ljuosblå wiįsteråva",
  "block.minecraft.banner.half_vertical.light_gray": "Ljuosgrå wįsteråva",
  "block.minecraft.banner.half_vertical.lime": "Laimgryönfergað wiįsteråva",
  "block.minecraft.banner.half_vertical.magenta": "Magenta wiįsteråva",
  "block.minecraft.banner.half_vertical.orange": "Guolroð wiįsteråva",
  "block.minecraft.banner.half_vertical.pink": "Stjär wįsteråva",
  "block.minecraft.banner.half_vertical.purple": "Lila wįsteråva",
  "block.minecraft.banner.half_vertical.red": "Roð wįsteråva",
  "block.minecraft.banner.half_vertical.white": "Wait wiįsteråva",
  "block.minecraft.banner.half_vertical.yellow": "Guol wiįsteråva",
  "block.minecraft.banner.half_vertical_right.black": "Swart yögeråva",
  "block.minecraft.banner.half_vertical_right.blue": "Blå yögeråva",
  "block.minecraft.banner.half_vertical_right.brown": "Brun yögeråva",
  "block.minecraft.banner.half_vertical_right.cyan": "Syanfeergað yögeråva",
  "block.minecraft.banner.half_vertical_right.gray": "Grå yögeråva",
  "block.minecraft.banner.half_vertical_right.green": "Gryön yögeråva",
  "block.minecraft.banner.half_vertical_right.light_blue": "Ljuosblå yögeråva",
  "block.minecraft.banner.half_vertical_right.light_gray": "Ljuosgrå yögeråva",
  "block.minecraft.banner.half_vertical_right.lime": "Laimgryönfergað yögeråva",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta yögeråva",
  "block.minecraft.banner.half_vertical_right.orange": "Guolroð yögeråva",
  "block.minecraft.banner.half_vertical_right.pink": "Stjär yögeråva",
  "block.minecraft.banner.half_vertical_right.purple": "Lila yögeråva",
  "block.minecraft.banner.half_vertical_right.red": "Roð yögeråva",
  "block.minecraft.banner.half_vertical_right.white": "Wait yögeråva",
  "block.minecraft.banner.half_vertical_right.yellow": "Guol yögeråva",
  "block.minecraft.banner.mojang.black": "Swart mojengg",
  "block.minecraft.banner.mojang.blue": "Blå pisyl",
  "block.minecraft.banner.mojang.brown": "Brun pisyl",
  "block.minecraft.banner.mojang.cyan": "Syanfergað pisyl",
  "block.minecraft.banner.mojang.gray": "Grå mojengg",
  "block.minecraft.banner.mojang.green": "Gryön mojengg",
  "block.minecraft.banner.mojang.light_blue": "Liuosblå mojengg",
  "block.minecraft.banner.mojang.light_gray": "Liuosgrå mojengg",
  "block.minecraft.banner.mojang.lime": "Limegryön mojengg",
  "block.minecraft.banner.mojang.magenta": "Liuoslila mojengg",
  "block.minecraft.banner.mojang.orange": "Guolroð mojengg",
  "block.minecraft.banner.mojang.pink": "Rosa mojengg",
  "block.minecraft.banner.mojang.purple": "Lila pisyl",
  "block.minecraft.banner.mojang.red": "Roð mojengg",
  "block.minecraft.banner.mojang.white": "Wait mojengg",
  "block.minecraft.banner.mojang.yellow": "Guol mojengg",
  "block.minecraft.banner.piglin.black": "Swartsnaut",
  "block.minecraft.banner.piglin.blue": "Blåsnaut",
  "block.minecraft.banner.piglin.brown": "Brunsnaut",
  "block.minecraft.banner.piglin.cyan": "Syanfergadsnaut",
  "block.minecraft.banner.piglin.gray": "Gråsnaut",
  "block.minecraft.banner.piglin.green": "Gryönsnaut",
  "block.minecraft.banner.piglin.light_blue": "Liuosblåsnaut",
  "block.minecraft.banner.piglin.light_gray": "Ljuousgråsnaut",
  "block.minecraft.banner.piglin.lime": "Laimgryönsnaut",
  "block.minecraft.banner.piglin.magenta": "Magentasnaut",
  "block.minecraft.banner.piglin.orange": "Guolroðsnaut",
  "block.minecraft.banner.piglin.pink": "Stjärsnaut",
  "block.minecraft.banner.piglin.purple": "Lilasnaut",
  "block.minecraft.banner.piglin.red": "Roðsnaut",
  "block.minecraft.banner.piglin.white": "Waitsnaut",
  "block.minecraft.banner.piglin.yellow": "Guolsnaut",
  "block.minecraft.banner.rhombus.black": "Swart diamant",
  "block.minecraft.banner.rhombus.blue": "Blå diamant",
  "block.minecraft.banner.rhombus.brown": "Brun diamant",
  "block.minecraft.banner.rhombus.cyan": "Syanfergað diamant",
  "block.minecraft.banner.rhombus.gray": "Grå diamant",
  "block.minecraft.banner.rhombus.green": "Gryön diamant",
  "block.minecraft.banner.rhombus.light_blue": "Ljuosblå diamant",
  "block.minecraft.banner.rhombus.light_gray": "Ljuosgrå diamant",
  "block.minecraft.banner.rhombus.lime": "Laimgryönfergað diamant",
  "block.minecraft.banner.rhombus.magenta": "Magentafergað diamant",
  "block.minecraft.banner.rhombus.orange": "Guolroð diamant",
  "block.minecraft.banner.rhombus.pink": "Stjär diamant",
  "block.minecraft.banner.rhombus.purple": "Lila diamant",
  "block.minecraft.banner.rhombus.red": "Roð diamant",
  "block.minecraft.banner.rhombus.white": "Wait diamant",
  "block.minecraft.banner.rhombus.yellow": "Guol diamant",
  "block.minecraft.banner.skull.black": "Swart doðskoll",
  "block.minecraft.banner.skull.blue": "Blå doðskoll",
  "block.minecraft.banner.skull.brown": "Brun doðskoll",
  "block.minecraft.banner.skull.cyan": "Syanfergað doðskoll",
  "block.minecraft.banner.skull.gray": "Grå doðskoll",
  "block.minecraft.banner.skull.green": "Gryön doðskoll",
  "block.minecraft.banner.skull.light_blue": "Liuosblå doðskoll",
  "block.minecraft.banner.skull.light_gray": "Liusgrå doðskoll",
  "block.minecraft.banner.skull.lime": "Laimgryönfergað doðskoll",
  "block.minecraft.banner.skull.magenta": "Magenta doðskoll",
  "block.minecraft.banner.skull.orange": "Guolroð doðskoll",
  "block.minecraft.banner.skull.pink": "Stjär doðskoll",
  "block.minecraft.banner.skull.purple": "Lila doðskoll",
  "block.minecraft.banner.skull.red": "Roð doðskoll",
  "block.minecraft.banner.skull.white": "Wait doðskoll",
  "block.minecraft.banner.skull.yellow": "Guol doðskoll",
  "block.minecraft.banner.small_stripes.black": "Swartrandun",
  "block.minecraft.banner.small_stripes.blue": "Blårandun",
  "block.minecraft.banner.small_stripes.brown": "Brunrandun",
  "block.minecraft.banner.small_stripes.cyan": "Cyanfergaðrandun",
  "block.minecraft.banner.small_stripes.gray": "Grårandun",
  "block.minecraft.banner.small_stripes.green": "Gryönrandun",
  "block.minecraft.banner.small_stripes.light_blue": "Ljuosblårandun",
  "block.minecraft.banner.small_stripes.light_gray": "Ljuosgrårandun",
  "block.minecraft.banner.small_stripes.lime": "Laimgryönrandun",
  "block.minecraft.banner.small_stripes.magenta": "Magentarandun",
  "block.minecraft.banner.small_stripes.orange": "Guolroðrandun",
  "block.minecraft.banner.small_stripes.pink": "Stjärrandun",
  "block.minecraft.banner.small_stripes.purple": "Lilarandun",
  "block.minecraft.banner.small_stripes.red": "Roðrandun",
  "block.minecraft.banner.small_stripes.white": "Waitrandun",
  "block.minecraft.banner.small_stripes.yellow": "Guolrandun",
  "block.minecraft.banner.square_bottom_left.black": "Swart niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.blue": "Blå niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.brown": "Brun niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.cyan": "Cyanfergað niderkant að wįster",
  "block.minecraft.banner.square_bottom_left.gray": "Grå niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.green": "Gryön niderkant ad wįster",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ljuosblå niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ljuosgrå niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.lime": "Laimfergað niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.magenta": "Magentafergað niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.orange": "Guolrod niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.pink": "Stjär niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.purple": "Lila niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.red": "Roð niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.white": "Wait niðerkant að wįster",
  "block.minecraft.banner.square_bottom_left.yellow": "Guol niðerkant að wįster",
  "block.minecraft.banner.square_bottom_right.black": "Swart nidoni að yöger",
  "block.minecraft.banner.square_bottom_right.blue": "Blå niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.brown": "Brun niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.cyan": "Syanfergað niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.gray": "Grå niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.green": "Gryön niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.light_blue": "Ljuiosblå niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ljuosgrå niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.lime": "Laimgryönfergað niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.magenta": "Magentafergað niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.orange": "Guolrod niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.pink": "Stjär niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.purple": "Lila niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.red": "Roð niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.white": "Wait niðoni að yöger",
  "block.minecraft.banner.square_bottom_right.yellow": "Guol niðoni að yöger",
  "block.minecraft.banner.square_top_left.black": "Swart yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.blue": "Blå yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.brown": "Brun yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.cyan": "Syanfergað yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.gray": "Grå yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.green": "Gryön yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.light_blue": "Ljuosblå yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.light_gray": "Ljuosgrå yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.lime": "Laimgryönfergað yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.magenta": "Magentafergad yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.orange": "Guolroð yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.pink": "Stjär yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.purple": "Lila yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.red": "Roð yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.white": "Wait yvyrkant að wįster",
  "block.minecraft.banner.square_top_left.yellow": "Guol yvyrkant að wįster",
  "block.minecraft.banner.square_top_right.black": "Swart uvoni að yöger",
  "block.minecraft.banner.square_top_right.blue": "Blå uvoni að yöger",
  "block.minecraft.banner.square_top_right.brown": "Brun uvoni að yöger",
  "block.minecraft.banner.square_top_right.cyan": "Syanfergað uvoni að yöger",
  "block.minecraft.banner.square_top_right.gray": "Grå uvoni að yöger",
  "block.minecraft.banner.square_top_right.green": "Gryön uvoni að yöger",
  "block.minecraft.banner.square_top_right.light_blue": "Ljuosblå uvoni að yöger",
  "block.minecraft.banner.square_top_right.light_gray": "Ljuosgrå uvoni að yöger",
  "block.minecraft.banner.square_top_right.lime": "Laimgryönfergað uvoni að yöger",
  "block.minecraft.banner.square_top_right.magenta": "Magenta uvoni að yöger",
  "block.minecraft.banner.square_top_right.orange": "Guolroð uvoni að yöger",
  "block.minecraft.banner.square_top_right.pink": "Stjär uvoni að yöger",
  "block.minecraft.banner.square_top_right.purple": "Lila uvoni að yöger",
  "block.minecraft.banner.square_top_right.red": "Roð uvoni að yöger",
  "block.minecraft.banner.square_top_right.white": "Wait uvoni að yöger",
  "block.minecraft.banner.square_top_right.yellow": "Guol uvoni að yöger",
  "block.minecraft.banner.straight_cross.black": "Swart kross",
  "block.minecraft.banner.straight_cross.blue": "Blått kross",
  "block.minecraft.banner.straight_cross.brown": "Brunt kross",
  "block.minecraft.banner.straight_cross.cyan": "Cyanfergað kross",
  "block.minecraft.banner.straight_cross.gray": "Grått kross",
  "block.minecraft.banner.straight_cross.green": "Gryönt kross",
  "block.minecraft.banner.straight_cross.light_blue": "Liuosblått kross",
  "block.minecraft.banner.straight_cross.light_gray": "Ljuosgrå'tt kross",
  "block.minecraft.banner.straight_cross.lime": "Laimgryönfergað kross",
  "block.minecraft.banner.straight_cross.magenta": "Magenta kross",
  "block.minecraft.banner.straight_cross.orange": "Guolrott kross",
  "block.minecraft.banner.straight_cross.pink": "Stjärt kross",
  "block.minecraft.banner.straight_cross.purple": "Lila kross",
  "block.minecraft.banner.straight_cross.red": "Rott kross",
  "block.minecraft.banner.straight_cross.white": "Wait kross",
  "block.minecraft.banner.straight_cross.yellow": "Guolt kross",
  "block.minecraft.banner.stripe_bottom.black": "Swart niðerkant",
  "block.minecraft.banner.stripe_bottom.blue": "Blå niðerkant",
  "block.minecraft.banner.stripe_bottom.brown": "Brun niðerkant",
  "block.minecraft.banner.stripe_bottom.cyan": "Syanfergad niðerkant",
  "block.minecraft.banner.stripe_bottom.gray": "Grå niðerkant",
  "block.minecraft.banner.stripe_bottom.green": "Gryön niðerkant",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ljuosblå niðerkant",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ljuosgrå niðerkant",
  "block.minecraft.banner.stripe_bottom.lime": "Laimgryönfergað niðerkant",
  "block.minecraft.banner.stripe_bottom.magenta": "Magentafergad niðerkant",
  "block.minecraft.banner.stripe_bottom.orange": "Guolrod niðerkant",
  "block.minecraft.banner.stripe_bottom.pink": "Stjär niðerkant",
  "block.minecraft.banner.stripe_bottom.purple": "Lila niðerkant",
  "block.minecraft.banner.stripe_bottom.red": "Roð niðerkant",
  "block.minecraft.banner.stripe_bottom.white": "Wait niðerkant",
  "block.minecraft.banner.stripe_bottom.yellow": "Guol niðerkant",
  "block.minecraft.banner.stripe_center.black": "Swartstrik",
  "block.minecraft.banner.stripe_center.blue": "Blått strik",
  "block.minecraft.banner.stripe_center.brown": "Brunt strik",
  "block.minecraft.banner.stripe_center.cyan": "Cyanfergad strik",
  "block.minecraft.banner.stripe_center.gray": "Grått strik",
  "block.minecraft.banner.stripe_center.green": "Gryönt strik",
  "block.minecraft.banner.stripe_center.light_blue": "Ljuosblå strik",
  "block.minecraft.banner.stripe_center.light_gray": "Ljuosgrått strik",
  "block.minecraft.banner.stripe_center.lime": "Laimgryönfergað strik",
  "block.minecraft.banner.stripe_center.magenta": "Magenta strik",
  "block.minecraft.banner.stripe_center.orange": "Guolrot strik",
  "block.minecraft.banner.stripe_center.pink": "Stjätr strik",
  "block.minecraft.banner.stripe_center.purple": "Lila strik",
  "block.minecraft.banner.stripe_center.red": "Roðstrik",
  "block.minecraft.banner.stripe_center.white": "Wait strik",
  "block.minecraft.banner.stripe_center.yellow": "Guolt strik",
  "block.minecraft.banner.stripe_downleft.black": "Swart avut kroppstrik",
  "block.minecraft.banner.stripe_downleft.blue": "Blått avut kroppstrik",
  "block.minecraft.banner.stripe_downleft.brown": "Brunt avut kroppstrik",
  "block.minecraft.banner.stripe_downleft.cyan": "Syanfergað avut kroppstrik",
  "block.minecraft.banner.stripe_downleft.gray": "Grått avut kroppstrik",
  "block.minecraft.banner.stripe_downleft.green": "Gryönt avut kroppstrik",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ljuosblått kroppstrik",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ljuosgrått avut kroppstrik",
  "block.minecraft.banner.stripe_downleft.lime": "Laimgryönfergað avut kroppstrik",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta kroppstrik",
  "block.minecraft.banner.stripe_downleft.orange": "Guolroð kroppstrik",
  "block.minecraft.banner.stripe_downleft.pink": "Stjärt avut kroppstrik",
  "block.minecraft.banner.stripe_downleft.purple": "Lila avut kroppstrik",
  "block.minecraft.banner.stripe_downleft.red": "Rott avut kroppstrik",
  "block.minecraft.banner.stripe_downleft.white": "Wait kroppstrik",
  "block.minecraft.banner.stripe_downleft.yellow": "Guolt avut kroppstrik",
  "block.minecraft.banner.stripe_downright.black": "Swart kroppstrik",
  "block.minecraft.banner.stripe_downright.blue": "Blå'tt kroppsrtrik",
  "block.minecraft.banner.stripe_downright.brown": "Brunt kroppstrik",
  "block.minecraft.banner.stripe_downright.cyan": "Syanfgergad kroppstrik",
  "block.minecraft.banner.stripe_downright.gray": "Grått kroppstrik",
  "block.minecraft.banner.stripe_downright.green": "Gryönt kroppstrik",
  "block.minecraft.banner.stripe_downright.light_blue": "Ljusblått kroppstrik",
  "block.minecraft.banner.stripe_downright.light_gray": "Ljuosgrå kroppstrik",
  "block.minecraft.banner.stripe_downright.lime": "Laimfergað kroppstrik",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta kroppstrik",
  "block.minecraft.banner.stripe_downright.orange": "Guolrott kroppstrik",
  "block.minecraft.banner.stripe_downright.pink": "Stjärt kroppstrik",
  "block.minecraft.banner.stripe_downright.purple": "Lila kroppstrik",
  "block.minecraft.banner.stripe_downright.red": "Rott kroppstrik",
  "block.minecraft.banner.stripe_downright.white": "Wait kroppstrik",
  "block.minecraft.banner.stripe_downright.yellow": "Guolt kroppstrik",
  "block.minecraft.banner.stripe_left.black": "Swart að wįster",
  "block.minecraft.banner.stripe_left.blue": "Blå að wįster",
  "block.minecraft.banner.stripe_left.brown": "Brun að wįster",
  "block.minecraft.banner.stripe_left.cyan": "Syanfergað að wįster",
  "block.minecraft.banner.stripe_left.gray": "Grå að wįster",
  "block.minecraft.banner.stripe_left.green": "Gryön að wįster",
  "block.minecraft.banner.stripe_left.light_blue": "Ljuosblå að wįster",
  "block.minecraft.banner.stripe_left.light_gray": "Ljuosgrå að wįster",
  "block.minecraft.banner.stripe_left.lime": "Laimgryönfergad að wįster",
  "block.minecraft.banner.stripe_left.magenta": "Magentafergað að wįster",
  "block.minecraft.banner.stripe_left.orange": "Guolroð að wįster",
  "block.minecraft.banner.stripe_left.pink": "Stjär að wįster",
  "block.minecraft.banner.stripe_left.purple": "Lila að wįster",
  "block.minecraft.banner.stripe_left.red": "Roð að wįster",
  "block.minecraft.banner.stripe_left.white": "Wait að wįster",
  "block.minecraft.banner.stripe_left.yellow": "Guol að wįster",
  "block.minecraft.banner.stripe_middle.black": "Swart liggend strik",
  "block.minecraft.banner.stripe_middle.blue": "Blått liggend strik",
  "block.minecraft.banner.stripe_middle.brown": "Brunt liggend strik",
  "block.minecraft.banner.stripe_middle.cyan": "Cyanfergad liggend strik",
  "block.minecraft.banner.stripe_middle.gray": "Grått liggend strik",
  "block.minecraft.banner.stripe_middle.green": "Gryönt liggend strik",
  "block.minecraft.banner.stripe_middle.light_blue": "Ljuosblått liggend strik",
  "block.minecraft.banner.stripe_middle.light_gray": "Ljuosgrått liggend strik",
  "block.minecraft.banner.stripe_middle.lime": "Laimgrytönfergað liggend strik",
  "block.minecraft.banner.stripe_middle.magenta": "Magentafergað liggend strik",
  "block.minecraft.banner.stripe_middle.orange": "Guolrott liggend strik",
  "block.minecraft.banner.stripe_middle.pink": "Stjärtt liggend strik",
  "block.minecraft.banner.stripe_middle.purple": "Lila liggend strik",
  "block.minecraft.banner.stripe_middle.red": "Rott liggend strik",
  "block.minecraft.banner.stripe_middle.white": "Wai'tt liggend strik",
  "block.minecraft.banner.stripe_middle.yellow": "Guolt liggend strik",
  "block.minecraft.banner.stripe_right.black": "Swart að yöger",
  "block.minecraft.banner.stripe_right.blue": "Blå að yöger",
  "block.minecraft.banner.stripe_right.brown": "Brun að yöger",
  "block.minecraft.banner.stripe_right.cyan": "Syanfergað að yöger",
  "block.minecraft.banner.stripe_right.gray": "Grå að yöger",
  "block.minecraft.banner.stripe_right.green": "Gryön að yöger",
  "block.minecraft.banner.stripe_right.light_blue": "Ljuosblå að yöger",
  "block.minecraft.banner.stripe_right.light_gray": "Ljuosgrå að yöger",
  "block.minecraft.banner.stripe_right.lime": "Laimfergad að yöger",
  "block.minecraft.banner.stripe_right.magenta": "Magenta að yöger",
  "block.minecraft.banner.stripe_right.orange": "Guolroð að yöger",
  "block.minecraft.banner.stripe_right.pink": "Stjär að yöger",
  "block.minecraft.banner.stripe_right.purple": "Lila að yöger",
  "block.minecraft.banner.stripe_right.red": "Roð að yöger",
  "block.minecraft.banner.stripe_right.white": "Wait að yöger",
  "block.minecraft.banner.stripe_right.yellow": "Guol að yöger",
  "block.minecraft.banner.stripe_top.black": "Swart yvyrkant",
  "block.minecraft.banner.stripe_top.blue": "Blå yvyrkant",
  "block.minecraft.banner.stripe_top.brown": "Brun yvyrkant",
  "block.minecraft.banner.stripe_top.cyan": "Syanfergað yvyrkant",
  "block.minecraft.banner.stripe_top.gray": "Grå yvyrkant",
  "block.minecraft.banner.stripe_top.green": "Gryön yvyrkant",
  "block.minecraft.banner.stripe_top.light_blue": "Ljusblå yvyrkant",
  "block.minecraft.banner.stripe_top.light_gray": "Ljuosgrå yvyrkant",
  "block.minecraft.banner.stripe_top.lime": "Laimgryönfergað yvyrkant",
  "block.minecraft.banner.stripe_top.magenta": "Magenta yvyrkant",
  "block.minecraft.banner.stripe_top.orange": "Guolrod yvyrkant",
  "block.minecraft.banner.stripe_top.pink": "Stjär yvyrkant",
  "block.minecraft.banner.stripe_top.purple": "Lila yvyrkant",
  "block.minecraft.banner.stripe_top.red": "Roð yvyrkant",
  "block.minecraft.banner.stripe_top.white": "Wait yvyrkant",
  "block.minecraft.banner.stripe_top.yellow": "Guol yvyrkant",
  "block.minecraft.banner.triangle_bottom.black": "Swarttrianggel niðoni",
  "block.minecraft.banner.triangle_bottom.blue": "Blåtrianggel niðoni",
  "block.minecraft.banner.triangle_bottom.brown": "Bruntrianggel niðoni",
  "block.minecraft.banner.triangle_bottom.cyan": "Syanfergaðtrianggel niðoni",
  "block.minecraft.banner.triangle_bottom.gray": "Gråtrianggel niðoni",
  "block.minecraft.banner.triangle_bottom.green": "Gryöntrianggel niðoni",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ljuosblåtrianggel niðoni",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ljuosgråtrianggel niðoni",
  "block.minecraft.banner.triangle_bottom.lime": "Limefergaðwinkel niðoni",
  "block.minecraft.banner.triangle_bottom.magenta": "Magentawinkel niðoni",
  "block.minecraft.banner.triangle_bottom.orange": "Guolroð winkel niðoni",
  "block.minecraft.banner.triangle_bottom.pink": "Stjärtrianggel niðoni",
  "block.minecraft.banner.triangle_bottom.purple": "Lilatrianggel niðoni",
  "block.minecraft.banner.triangle_bottom.red": "Roðtrianggel niðoni",
  "block.minecraft.banner.triangle_bottom.white": "Waitwinkel niðoni",
  "block.minecraft.banner.triangle_bottom.yellow": "Guolwinkel niðoni",
  "block.minecraft.banner.triangle_top.black": "Swart avun trianggel",
  "block.minecraft.banner.triangle_top.blue": "Blå avuntrianggel uvoni",
  "block.minecraft.banner.triangle_top.brown": "Brun avuntrianggel uvoni",
  "block.minecraft.banner.triangle_top.cyan": "Syanfergað avutriangel uvoni",
  "block.minecraft.banner.triangle_top.gray": "Grå avuntrianggel uvoni",
  "block.minecraft.banner.triangle_top.green": "Gryön avun trianggel uvoni",
  "block.minecraft.banner.triangle_top.light_blue": "Ljuosblåavuntrianggel uvoni",
  "block.minecraft.banner.triangle_top.light_gray": "Ljuosgrå avuntrianggel uvoni",
  "block.minecraft.banner.triangle_top.lime": "Laimfergaðavuntrianggel uvoni",
  "block.minecraft.banner.triangle_top.magenta": "Magentafergað avuntrianggel uvoni",
  "block.minecraft.banner.triangle_top.orange": "Guolroð avuntrianggel uvoni",
  "block.minecraft.banner.triangle_top.pink": "Stjär avuntrianggel uvoni",
  "block.minecraft.banner.triangle_top.purple": "Lila avuntrianggel uvoni",
  "block.minecraft.banner.triangle_top.red": "Roð avun trianggel",
  "block.minecraft.banner.triangle_top.white": "Waitavuntrianggel uvoni",
  "block.minecraft.banner.triangle_top.yellow": "Guol avuntrianggel uvoni",
  "block.minecraft.banner.triangles_bottom.black": "Swarttagger niðoni",
  "block.minecraft.banner.triangles_bottom.blue": "Blåtagger niðoni",
  "block.minecraft.banner.triangles_bottom.brown": "Bruntagger niðoni",
  "block.minecraft.banner.triangles_bottom.cyan": "Syanfergaðtagger niðoni",
  "block.minecraft.banner.triangles_bottom.gray": "Gråtagger niðoni",
  "block.minecraft.banner.triangles_bottom.green": "Gryöntagger niðoni",
  "block.minecraft.banner.triangles_bottom.light_blue": "Ljuosblåtagger niðoni",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ljuosgråtagger niðoni",
  "block.minecraft.banner.triangles_bottom.lime": "Laimfergaðtagger niðoni",
  "block.minecraft.banner.triangles_bottom.magenta": "Magentatagger niðoni",
  "block.minecraft.banner.triangles_bottom.orange": "Guolroðtagger niðoni",
  "block.minecraft.banner.triangles_bottom.pink": "Stjärtagger niðoni",
  "block.minecraft.banner.triangles_bottom.purple": "Lilatagger niðoni",
  "block.minecraft.banner.triangles_bottom.red": "Roðtagger niðoni",
  "block.minecraft.banner.triangles_bottom.white": "Waittagger niðoni",
  "block.minecraft.banner.triangles_bottom.yellow": "Guoltagger niðoni",
  "block.minecraft.banner.triangles_top.black": "Swarttagger uvoni",
  "block.minecraft.banner.triangles_top.blue": "Blåtagger uvoni",
  "block.minecraft.banner.triangles_top.brown": "Bruntagger uvoni",
  "block.minecraft.banner.triangles_top.cyan": "Syafergaðtagger uvoni",
  "block.minecraft.banner.triangles_top.gray": "Gråtagger uvoni",
  "block.minecraft.banner.triangles_top.green": "Gryöntagger uvoni",
  "block.minecraft.banner.triangles_top.light_blue": "Ljuosblåtagger uvoni",
  "block.minecraft.banner.triangles_top.light_gray": "Ljuosgråtagger uvoni",
  "block.minecraft.banner.triangles_top.lime": "Laimfergaðtagger uvoni",
  "block.minecraft.banner.triangles_top.magenta": "Magentatagger uvoni",
  "block.minecraft.banner.triangles_top.orange": "Guolroðtagger uvoni",
  "block.minecraft.banner.triangles_top.pink": "Stjärtagger uvoni",
  "block.minecraft.banner.triangles_top.purple": "Lilatagger uvoni",
  "block.minecraft.banner.triangles_top.red": "Roðtagger uvoni",
  "block.minecraft.banner.triangles_top.white": "Waittagger uvoni",
  "block.minecraft.banner.triangles_top.yellow": "Guoltagger uvoni",
  "block.minecraft.barrel": "Tunna",
  "block.minecraft.barrier": "Inder",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Fyr",
  "block.minecraft.beacon.primary": "Fuostkraft",
  "block.minecraft.beacon.secondary": "Oðerkraftn",
  "block.minecraft.bed.no_sleep": "Du belelr bar såvå um not og dar eð åsker",
  "block.minecraft.bed.not_safe": "Du beller it wail dig nų, monstrer iro jär noger",
  "block.minecraft.bed.obstructed": "Issujär saindję ir blokkirað",
  "block.minecraft.bed.occupied": "Issujär saindję ir upptaið",
  "block.minecraft.bed.too_far_away": "Du beller it wail dig nų, sandję ir uvlaunggt brott",
  "block.minecraft.bedrock": "Bjärggrund",
  "block.minecraft.bee_nest": "Bisamell",
  "block.minecraft.beehive": "Bikup",
  "block.minecraft.beetroots": "Roðbietur",
  "block.minecraft.bell": "Rindjklukk",
  "block.minecraft.big_dripleaf": "Struru druplovę",
  "block.minecraft.big_dripleaf_stem": "Stur druplovsstiuok",
  "block.minecraft.birch_button": "Byörkknapp",
  "block.minecraft.birch_door": "Byörkdörer",
  "block.minecraft.birch_fence": "Byörkstakiet",
  "block.minecraft.birch_fence_gate": "Grind i byörkstakiet",
  "block.minecraft.birch_hanging_sign": "Hängande björkskylt",
  "block.minecraft.birch_leaves": "Byörklov",
  "block.minecraft.birch_log": "Byörkkabb",
  "block.minecraft.birch_planks": "Byörkplaunkur",
  "block.minecraft.birch_pressure_plate": "Byörkpressplatt",
  "block.minecraft.birch_sapling": "Byörkplemta",
  "block.minecraft.birch_shelf": "Björkhylla",
  "block.minecraft.birch_sign": "Byörkstjylt",
  "block.minecraft.birch_slab": "Byörkstjiv",
  "block.minecraft.birch_stairs": "Byörktrampur",
  "block.minecraft.birch_trapdoor": "Byörkfollukku",
  "block.minecraft.birch_wall_hanging_sign": "Hängande björkskylt på vägg",
  "block.minecraft.birch_wall_sign": "Byörkweggstjylt",
  "block.minecraft.birch_wood": "Byörkwiðn",
  "block.minecraft.black_banner": "Swart fana",
  "block.minecraft.black_bed": "Swart saingg",
  "block.minecraft.black_candle": "Swart stiarinljuos",
  "block.minecraft.black_candle_cake": "Tårt min swar´tt liuos",
  "block.minecraft.black_carpet": "Swart matta",
  "block.minecraft.black_concrete": "Swart bitongg",
  "block.minecraft.black_concrete_powder": "Swart bitongpulver",
  "block.minecraft.black_glazed_terracotta": "Swartglasirað terrakotta",
  "block.minecraft.black_shulker_box": "Swart shulkerlåð",
  "block.minecraft.black_stained_glass": "Swartflekkaðglas",
  "block.minecraft.black_stained_glass_pane": "Swartflekkaðglasrut",
  "block.minecraft.black_terracotta": "Swart terrakotta",
  "block.minecraft.black_wool": "Swart ull",
  "block.minecraft.blackstone": "Swartstien",
  "block.minecraft.blackstone_slab": "Swartstįestjiv",
  "block.minecraft.blackstone_stairs": "Swartstįetrampur",
  "block.minecraft.blackstone_wall": "Swartstįemuor",
  "block.minecraft.blast_furnace": "Blästungen",
  "block.minecraft.blue_banner": "Blå fana",
  "block.minecraft.blue_bed": "Blå saingg",
  "block.minecraft.blue_candle": "Blått stiarinljuos",
  "block.minecraft.blue_candle_cake": "Tårt min blå´tt liuos",
  "block.minecraft.blue_carpet": "Blå matta",
  "block.minecraft.blue_concrete": "Blå bitongg",
  "block.minecraft.blue_concrete_powder": "Blå bitonggpulver",
  "block.minecraft.blue_glazed_terracotta": "Blåglasirað terrakotta",
  "block.minecraft.blue_ice": "Blåaisn",
  "block.minecraft.blue_orchid": "Blå uortjiði",
  "block.minecraft.blue_shulker_box": "Blå shulkerlåð",
  "block.minecraft.blue_stained_glass": "Blåflekkaðglas",
  "block.minecraft.blue_stained_glass_pane": "Blåflekkaðglasrut",
  "block.minecraft.blue_terracotta": "Blå terrakotta",
  "block.minecraft.blue_wool": "Blå ull",
  "block.minecraft.bone_block": "Bįeblokk",
  "block.minecraft.bookshelf": "Buokill",
  "block.minecraft.brain_coral": "Iennkorall",
  "block.minecraft.brain_coral_block": "Iennkorallblokk",
  "block.minecraft.brain_coral_fan": "Iennkorallflekt",
  "block.minecraft.brain_coral_wall_fan": "Iennkorallväggsflekt",
  "block.minecraft.brewing_stand": "Bryggstellningg",
  "block.minecraft.brick_slab": "Tigelstjiv",
  "block.minecraft.brick_stairs": "Tigelstįetrampur",
  "block.minecraft.brick_wall": "Tigelstiewegg",
  "block.minecraft.bricks": "Tigelstiener",
  "block.minecraft.brown_banner": "Brun fana",
  "block.minecraft.brown_bed": "Brun saingg",
  "block.minecraft.brown_candle": "Brunt stiarinljuos",
  "block.minecraft.brown_candle_cake": "Tårt min brunt liuos",
  "block.minecraft.brown_carpet": "Brun matta",
  "block.minecraft.brown_concrete": "Brun bitongg",
  "block.minecraft.brown_concrete_powder": "Brun bitonggpulver",
  "block.minecraft.brown_glazed_terracotta": "Brunglasirað terrakotta",
  "block.minecraft.brown_mushroom": "Brunsopp",
  "block.minecraft.brown_mushroom_block": "Brun soppblokk",
  "block.minecraft.brown_shulker_box": "Brun shulkerlåð",
  "block.minecraft.brown_stained_glass": "Brunflekkaðglas",
  "block.minecraft.brown_stained_glass_pane": "Brunflekkaðglasrut",
  "block.minecraft.brown_terracotta": "Brun terakotta",
  "block.minecraft.brown_wool": "Brun ull",
  "block.minecraft.bubble_column": "Bubbelpilår",
  "block.minecraft.bubble_coral": "Bubbelkorall",
  "block.minecraft.bubble_coral_block": "Bubbelkorallblokk",
  "block.minecraft.bubble_coral_fan": "Bubbelkorallflekt",
  "block.minecraft.bubble_coral_wall_fan": "Bubbelkorallweggsflekt",
  "block.minecraft.budding_amethyst": "Knuppend ametist",
  "block.minecraft.bush": "Buske",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblomma",
  "block.minecraft.cake": "Tårta",
  "block.minecraft.calcite": "Kalkspat",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrerad sculksensor",
  "block.minecraft.campfire": "Sovujäld",
  "block.minecraft.candle": "Stiarinljuos",
  "block.minecraft.candle_cake": "Stiariniuostårt",
  "block.minecraft.carrots": "Mųoruotur",
  "block.minecraft.cartography_table": "Kartriterbuord",
  "block.minecraft.carved_pumpkin": "Skurin pumpa",
  "block.minecraft.cauldron": "Ketil",
  "block.minecraft.cave_air": "Grottweðreð",
  "block.minecraft.cave_vines": "Grottkleðerwekst",
  "block.minecraft.cave_vines_plant": "Grottkleðerwekstplempta",
  "block.minecraft.chain": "Tjaia",
  "block.minecraft.chain_command_block": "Umtagend kommandoblokk",
  "block.minecraft.cherry_button": "Körsbärsknapp",
  "block.minecraft.cherry_door": "Körsbärsdörr",
  "block.minecraft.cherry_fence": "Körsbärsstaket",
  "block.minecraft.cherry_fence_gate": "Körsbärsgrind",
  "block.minecraft.cherry_hanging_sign": "Hängande körsbärsskylt",
  "block.minecraft.cherry_leaves": "Körsbärslöv",
  "block.minecraft.cherry_log": "Körsbärsstam",
  "block.minecraft.cherry_planks": "Körsbärsplankor",
  "block.minecraft.cherry_pressure_plate": "Körsbärstryckplatta",
  "block.minecraft.cherry_sapling": "Körsbärsplanta",
  "block.minecraft.cherry_shelf": "Körsbärshylla",
  "block.minecraft.cherry_sign": "Körsbärsskylt",
  "block.minecraft.cherry_slab": "Körsbärsplatta",
  "block.minecraft.cherry_stairs": "Körsbärstrappa",
  "block.minecraft.cherry_trapdoor": "Körsbärsfallucka",
  "block.minecraft.cherry_wall_hanging_sign": "Hängande körsbärsskylt på vägg",
  "block.minecraft.cherry_wall_sign": "Körsbärsskylt på vägg",
  "block.minecraft.cherry_wood": "Körsbärsträ",
  "block.minecraft.chest": "Tjista",
  "block.minecraft.chipped_anvil": "Skardut smiðsteð",
  "block.minecraft.chiseled_bookshelf": "Mejslad bokhylla",
  "block.minecraft.chiseled_copper": "Mejslað kuppär",
  "block.minecraft.chiseled_deepslate": "Mejslað diuopstjiffer",
  "block.minecraft.chiseled_nether_bricks": "Mejslað Nethertigelstiener",
  "block.minecraft.chiseled_polished_blackstone": "Mejslad polirað swartstien",
  "block.minecraft.chiseled_quartz_block": "Mejslað kwartsblokk",
  "block.minecraft.chiseled_red_sandstone": "Mejslað roðsandstie",
  "block.minecraft.chiseled_resin_bricks": "Mejslat hartstegel",
  "block.minecraft.chiseled_sandstone": "Mejslað sandstie",
  "block.minecraft.chiseled_stone_bricks": "Mejslað stįetigelstie",
  "block.minecraft.chiseled_tuff": "Mejslað tuff",
  "block.minecraft.chiseled_tuff_bricks": "Mejslað tufftigelstiener",
  "block.minecraft.chorus_flower": "Körbljomme",
  "block.minecraft.chorus_plant": "Körplemt",
  "block.minecraft.clay": "Liera",
  "block.minecraft.closed_eyeblossom": "Stängd ögonblomma",
  "block.minecraft.coal_block": "Kuolblokk",
  "block.minecraft.coal_ore": "Kuolmalmsåðer",
  "block.minecraft.coarse_dirt": "Russlun muld",
  "block.minecraft.cobbled_deepslate": "Kullerstiensdiuopstjiffer",
  "block.minecraft.cobbled_deepslate_slab": "Stjiv ov Diuopstjifferstjiv",
  "block.minecraft.cobbled_deepslate_stairs": "Trampur åv kullerstiensdiuopstjiffer",
  "block.minecraft.cobbled_deepslate_wall": "Muor ov kullerstiensdiuopstjiffer",
  "block.minecraft.cobblestone": "Gatustie",
  "block.minecraft.cobblestone_slab": "Gatusįestjiv",
  "block.minecraft.cobblestone_stairs": "Gatustįetrampur",
  "block.minecraft.cobblestone_wall": "Gatustįewegg",
  "block.minecraft.cobweb": "Dyörgnęt",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Kommandoblokk",
  "block.minecraft.comparator": "Redstonejemfyörer",
  "block.minecraft.composter": "Suopendyndj",
  "block.minecraft.conduit": "Kultvert",
  "block.minecraft.copper_bars": "Koppargaller",
  "block.minecraft.copper_block": "Kupperblokk",
  "block.minecraft.copper_bulb": "Kuppärlampel",
  "block.minecraft.copper_chain": "Kopparkedja",
  "block.minecraft.copper_chest": "Kopparkista",
  "block.minecraft.copper_door": "Kuppärdörr",
  "block.minecraft.copper_golem_statue": "Koppargolemstaty",
  "block.minecraft.copper_grate": "Kuppärgaller",
  "block.minecraft.copper_lantern": "Kopparlykta",
  "block.minecraft.copper_ore": "Kuppärmåm",
  "block.minecraft.copper_torch": "Kopparfackla",
  "block.minecraft.copper_trapdoor": "Kuppärfollukku",
  "block.minecraft.copper_wall_torch": "Kopparfackla på vägg",
  "block.minecraft.cornflower": "Rugbljomm",
  "block.minecraft.cracked_deepslate_bricks": "Sprutjin diuopstjifferplatt muorstiener",
  "block.minecraft.cracked_deepslate_tiles": "Sprutjin diuopstjifferkakel",
  "block.minecraft.cracked_nether_bricks": "Rimnað Netherstiener",
  "block.minecraft.cracked_polished_blackstone_bricks": "Sprukkner swartstįestiener",
  "block.minecraft.cracked_stone_bricks": "Klumnað st stįetigelstie",
  "block.minecraft.crafter": "Tilwerker",
  "block.minecraft.crafting_table": "Arbietsbainkk",
  "block.minecraft.creaking_heart": "Knarrhjärta",
  "block.minecraft.creeper_head": "Creeper-ovuð",
  "block.minecraft.creeper_wall_head": "Creeperweggsovuð",
  "block.minecraft.crimson_button": "Mörkroð knapp",
  "block.minecraft.crimson_door": "Mörkroð dörer",
  "block.minecraft.crimson_fence": "Mörkrott stakiet",
  "block.minecraft.crimson_fence_gate": "Mörkroð dörer i stakiet",
  "block.minecraft.crimson_fungus": "Karmosinsopp",
  "block.minecraft.crimson_hanging_sign": "Hängande karmosinskylt",
  "block.minecraft.crimson_hyphae": "Karmosinyfer",
  "block.minecraft.crimson_nylium": "Karmosinnylium",
  "block.minecraft.crimson_planks": "Mörkroð plankur",
  "block.minecraft.crimson_pressure_plate": "Mörkroð trykkstjiv",
  "block.minecraft.crimson_roots": "Karmosinruotur",
  "block.minecraft.crimson_shelf": "Karmosinhylla",
  "block.minecraft.crimson_sign": "Mörkroð stjylt",
  "block.minecraft.crimson_slab": "Mörkroð stjiva",
  "block.minecraft.crimson_stairs": "Mörkroð trampur",
  "block.minecraft.crimson_stem": "Karmosinstam",
  "block.minecraft.crimson_trapdoor": "Mörkroð follukk",
  "block.minecraft.crimson_wall_hanging_sign": "Hängande karmosinskylt på vägg",
  "block.minecraft.crimson_wall_sign": "Mörkroð weggstylt",
  "block.minecraft.crying_obsidian": "Grainend obsidian",
  "block.minecraft.cut_copper": "Skurin kuppär",
  "block.minecraft.cut_copper_slab": "Skurin kuppärstjiv",
  "block.minecraft.cut_copper_stairs": "Trampur åv skurin kuppär",
  "block.minecraft.cut_red_sandstone": "Klippt sandstie",
  "block.minecraft.cut_red_sandstone_slab": "Klipptroðsandstiestjiv",
  "block.minecraft.cut_sandstone": "Klipptsandstie",
  "block.minecraft.cut_sandstone_slab": "Klippt sandstiestjiv",
  "block.minecraft.cyan_banner": "Syanfergað fana",
  "block.minecraft.cyan_bed": "Syansaingg",
  "block.minecraft.cyan_candle": "Syanfergað stiarinljuos",
  "block.minecraft.cyan_candle_cake": "Tårt min syanfergað liuos",
  "block.minecraft.cyan_carpet": "Syanfergað matta",
  "block.minecraft.cyan_concrete": "Syanfergað bitongg",
  "block.minecraft.cyan_concrete_powder": "Syanfergað bitonggpulver",
  "block.minecraft.cyan_glazed_terracotta": "Syanfergað glasirað terrakotta",
  "block.minecraft.cyan_shulker_box": "Cyanfergað shulkerlåð",
  "block.minecraft.cyan_stained_glass": "Syanflekkaðglas",
  "block.minecraft.cyan_stained_glass_pane": "Cyanflekkaðglasrut",
  "block.minecraft.cyan_terracotta": "Cyanfergað terrakotta",
  "block.minecraft.cyan_wool": "Syanfergað ull",
  "block.minecraft.damaged_anvil": "Skåðåð smiðsteð",
  "block.minecraft.dandelion": "Smyörbljomm",
  "block.minecraft.dark_oak_button": "Mörkiekknapp",
  "block.minecraft.dark_oak_door": "Mörkiekdörer",
  "block.minecraft.dark_oak_fence": "Mörkiekstakiet",
  "block.minecraft.dark_oak_fence_gate": "Grind i mörkiekstakiet",
  "block.minecraft.dark_oak_hanging_sign": "Hängande mörk ekskylt",
  "block.minecraft.dark_oak_leaves": "Mörkieklov",
  "block.minecraft.dark_oak_log": "Mörkiekkabb",
  "block.minecraft.dark_oak_planks": "Mörkiekplaunkur",
  "block.minecraft.dark_oak_pressure_plate": "Mörkiekpressplatt",
  "block.minecraft.dark_oak_sapling": "Mörkiekplemta",
  "block.minecraft.dark_oak_shelf": "Mörk ekhylla",
  "block.minecraft.dark_oak_sign": "Mörkiekstjylt",
  "block.minecraft.dark_oak_slab": "Mörkiekstjiv",
  "block.minecraft.dark_oak_stairs": "Mörkiektrampur",
  "block.minecraft.dark_oak_trapdoor": "Mörkiekfollukku",
  "block.minecraft.dark_oak_wall_hanging_sign": "Hängande mörk ekskylt på vägg",
  "block.minecraft.dark_oak_wall_sign": "Mörkiekweggstjylt",
  "block.minecraft.dark_oak_wood": "Mörkiekwiðn",
  "block.minecraft.dark_prismarine": "Mörk prismarin",
  "block.minecraft.dark_prismarine_slab": "Mörk prismarinstjiv",
  "block.minecraft.dark_prismarine_stairs": "Mörk prismarintrampur",
  "block.minecraft.daylight_detector": "Dagsljuosdetektor",
  "block.minecraft.dead_brain_coral": "Doð iennkorall",
  "block.minecraft.dead_brain_coral_block": "Doð iennkorallblokk",
  "block.minecraft.dead_brain_coral_fan": "Doð iennkorallflekt",
  "block.minecraft.dead_brain_coral_wall_fan": "Doð iennkorallweggsflekt",
  "block.minecraft.dead_bubble_coral": "Doð bubbelkorall",
  "block.minecraft.dead_bubble_coral_block": "Doð bubbellkorallblock",
  "block.minecraft.dead_bubble_coral_fan": "Doð bubbelkorallflekt",
  "block.minecraft.dead_bubble_coral_wall_fan": "Doð bubbelkorallweggsflekt",
  "block.minecraft.dead_bush": "Doð buoske",
  "block.minecraft.dead_fire_coral": "Doð jäldkorall",
  "block.minecraft.dead_fire_coral_block": "Doð jäldkorallblokk",
  "block.minecraft.dead_fire_coral_fan": "Doð jäldkorallflekt",
  "block.minecraft.dead_fire_coral_wall_fan": "Doð jäldkorallweggsflekt",
  "block.minecraft.dead_horn_coral": "Doð uonnkorall",
  "block.minecraft.dead_horn_coral_block": "Doð uonnkorallblokk",
  "block.minecraft.dead_horn_coral_fan": "Doð uonnkorallflekt",
  "block.minecraft.dead_horn_coral_wall_fan": "Doð uonnkorallweggsflekt",
  "block.minecraft.dead_tube_coral": "Doð rörkorall",
  "block.minecraft.dead_tube_coral_block": "Dod rörkorallblokk",
  "block.minecraft.dead_tube_coral_fan": "Doð rörkorallflekt",
  "block.minecraft.dead_tube_coral_wall_fan": "Doð rörkorallweggsflekt",
  "block.minecraft.decorated_pot": "Dekorerad keramikkruka",
  "block.minecraft.deepslate": "Diuopstjiffer",
  "block.minecraft.deepslate_brick_slab": "Platt åv diuopstjiffertigelstiener",
  "block.minecraft.deepslate_brick_stairs": "Trampur åv diuopstjiffertigelstiener",
  "block.minecraft.deepslate_brick_wall": "Diuopstjiffertigelstiemuor",
  "block.minecraft.deepslate_bricks": "Djuopstjiffertigelstie",
  "block.minecraft.deepslate_coal_ore": "Diuopstjifferkålåðer",
  "block.minecraft.deepslate_copper_ore": "Diuopstjifferkuppäråðer",
  "block.minecraft.deepslate_diamond_ore": "Diuopstjiffer diamantåðer",
  "block.minecraft.deepslate_emerald_ore": "Diuopstjiffersmaragdåðer",
  "block.minecraft.deepslate_gold_ore": "Diuopstjiffer gullåðer",
  "block.minecraft.deepslate_iron_ore": "Diuopstjiffer iennåðer",
  "block.minecraft.deepslate_lapis_ore": "Diuopstjiffer Lapis Lazuliåðer",
  "block.minecraft.deepslate_redstone_ore": "Diuopstjiffer roðstienåðer",
  "block.minecraft.deepslate_tile_slab": "Platt åv diuopstjifferkakel",
  "block.minecraft.deepslate_tile_stairs": "Trampur åv djuopsstjifferkakelplattur",
  "block.minecraft.deepslate_tile_wall": "Wegg åv djuopstjifferkakelplattur",
  "block.minecraft.deepslate_tiles": "Kaelplattur åv diuostiestjiffer",
  "block.minecraft.detector_rail": "Rels min detektor",
  "block.minecraft.diamond_block": "Diamantblokk",
  "block.minecraft.diamond_ore": "Diamantåder",
  "block.minecraft.diorite": "Diroit",
  "block.minecraft.diorite_slab": "Diroitstjiv",
  "block.minecraft.diorite_stairs": "Diorittrampur",
  "block.minecraft.diorite_wall": "Dioritwegg",
  "block.minecraft.dirt": "Muld",
  "block.minecraft.dirt_path": "Staig",
  "block.minecraft.dispenser": "Autdieler",
  "block.minecraft.dragon_egg": "Drakeddję",
  "block.minecraft.dragon_head": "Drakovuð",
  "block.minecraft.dragon_wall_head": "Drakweggsovuð",
  "block.minecraft.dried_ghast": "Uttorkad ghast",
  "block.minecraft.dried_kelp_block": "Blokk ov torkað alg",
  "block.minecraft.dripstone_block": "Druppstiensblokk",
  "block.minecraft.dropper": "Autmäter",
  "block.minecraft.emerald_block": "Smaragdblokk",
  "block.minecraft.emerald_ore": "Smaragdåðer",
  "block.minecraft.enchanting_table": "Fertrullninggsbuord",
  "block.minecraft.end_gateway": "Slutingangg",
  "block.minecraft.end_portal": "Slutportal",
  "block.minecraft.end_portal_frame": "Endportalram",
  "block.minecraft.end_rod": "Slutkevil",
  "block.minecraft.end_stone": "Slutstie",
  "block.minecraft.end_stone_brick_slab": "Endtigelsstįestjiv",
  "block.minecraft.end_stone_brick_stairs": "Endstįetigelstįetrampur",
  "block.minecraft.end_stone_brick_wall": "Slutstietigelstįewegg",
  "block.minecraft.end_stone_bricks": "Sluttigelstiener",
  "block.minecraft.ender_chest": "Endertjist",
  "block.minecraft.exposed_chiseled_copper": "Eksponirað mejslað kuppär",
  "block.minecraft.exposed_copper": "Kuppärn so synes",
  "block.minecraft.exposed_copper_bars": "Exponerat koppargaller",
  "block.minecraft.exposed_copper_bulb": "Eksponirað kuppärlampel",
  "block.minecraft.exposed_copper_chain": "Exponerad kopparkedja",
  "block.minecraft.exposed_copper_chest": "Exponerad kopparkista",
  "block.minecraft.exposed_copper_door": "Eksponirað kuppärdörr",
  "block.minecraft.exposed_copper_golem_statue": "Exponerad koppargolemstaty",
  "block.minecraft.exposed_copper_grate": "Eksponirað kuppärgaller",
  "block.minecraft.exposed_copper_lantern": "Exponerad kopparlykta",
  "block.minecraft.exposed_copper_trapdoor": "Eksponirað kuppärfollukku",
  "block.minecraft.exposed_cut_copper": "Eksponirað skurin kupär",
  "block.minecraft.exposed_cut_copper_slab": "Eksponirað kupärstjiv",
  "block.minecraft.exposed_cut_copper_stairs": "Eksponirað skurin kupärtrampur",
  "block.minecraft.exposed_lightning_rod": "Exponerad åskledare",
  "block.minecraft.farmland": "Åkerjuord",
  "block.minecraft.fern": "Uormbunk",
  "block.minecraft.fire": "Jäldn",
  "block.minecraft.fire_coral": "Jäldkorall",
  "block.minecraft.fire_coral_block": "Jäldkorallblokk",
  "block.minecraft.fire_coral_fan": "Jäldkorallflekt",
  "block.minecraft.fire_coral_wall_fan": "Jäldkorallweggsflekt",
  "block.minecraft.firefly_bush": "Eldflugsbuske",
  "block.minecraft.fletching_table": "Fletchinbuord",
  "block.minecraft.flower_pot": "Bljommkruk",
  "block.minecraft.flowering_azalea": "Asalea so bljommer",
  "block.minecraft.flowering_azalea_leaves": "Asalealover so bljommer",
  "block.minecraft.frogspawn": "Lunginrunned",
  "block.minecraft.frosted_ice": "Frostun ais",
  "block.minecraft.furnace": "Smeltungen",
  "block.minecraft.gilded_blackstone": "Gullsmitåð swartstien",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glasrut",
  "block.minecraft.glow_lichen": "Lavi so glyöðer",
  "block.minecraft.glowstone": "Glyöðstien",
  "block.minecraft.gold_block": "Gullblokk",
  "block.minecraft.gold_ore": "Gullåðer",
  "block.minecraft.golden_dandelion": "Gyllene maskros",
  "block.minecraft.granite": "Koppustie",
  "block.minecraft.granite_slab": "Granitstjiv",
  "block.minecraft.granite_stairs": "Granittrampur",
  "block.minecraft.granite_wall": "Granitwegg",
  "block.minecraft.grass": "Gras",
  "block.minecraft.grass_block": "Grasblokk",
  "block.minecraft.gravel": "Gruseð",
  "block.minecraft.gray_banner": "Grå fana",
  "block.minecraft.gray_bed": "Grå saingg",
  "block.minecraft.gray_candle": "Grått stiarinljuos",
  "block.minecraft.gray_candle_cake": "Tårt min grått liuos",
  "block.minecraft.gray_carpet": "Grå matta",
  "block.minecraft.gray_concrete": "Grå bitongg",
  "block.minecraft.gray_concrete_powder": "Grå bitonggpulver",
  "block.minecraft.gray_glazed_terracotta": "Gråglasirað terrakotta",
  "block.minecraft.gray_shulker_box": "Grå shulkerlåð",
  "block.minecraft.gray_stained_glass": "Gråflekkaðglas",
  "block.minecraft.gray_stained_glass_pane": "Gråflekkaðglasrut",
  "block.minecraft.gray_terracotta": "Grå terrakotta",
  "block.minecraft.gray_wool": "Grå ull",
  "block.minecraft.green_banner": "Gryön fana",
  "block.minecraft.green_bed": "Gryön saingg",
  "block.minecraft.green_candle": "Gryönt stiarinljuos",
  "block.minecraft.green_candle_cake": "Tårt min gryönt liuos",
  "block.minecraft.green_carpet": "Gryön matta",
  "block.minecraft.green_concrete": "Gryön bitongg",
  "block.minecraft.green_concrete_powder": "Gryön bitonggpulver",
  "block.minecraft.green_glazed_terracotta": "Gryönglasirað terrakotta",
  "block.minecraft.green_shulker_box": "Gryön shulkerlåð",
  "block.minecraft.green_stained_glass": "Gryönflekkaðglas",
  "block.minecraft.green_stained_glass_pane": "Gryönflekkaðglasrut",
  "block.minecraft.green_terracotta": "Gryön terrakotta",
  "block.minecraft.green_wool": "Gryön ull",
  "block.minecraft.grindstone": "Slipstie",
  "block.minecraft.hanging_roots": "Aindjend ruotur",
  "block.minecraft.hay_block": "Öbal",
  "block.minecraft.heavy_core": "Tung kärna",
  "block.minecraft.heavy_weighted_pressure_plate": "Tungg pressplatt",
  "block.minecraft.honey_block": "Onunggsblokk",
  "block.minecraft.honeycomb_block": "Wakskakublokk",
  "block.minecraft.hopper": "Tratt",
  "block.minecraft.horn_coral": "Uonnkorall",
  "block.minecraft.horn_coral_block": "Uonnkorallblokk",
  "block.minecraft.horn_coral_fan": "Uonnkorallflekt",
  "block.minecraft.horn_coral_wall_fan": "Uonnkorallweggsflekt",
  "block.minecraft.ice": "Aisn",
  "block.minecraft.infested_chiseled_stone_bricks": "Smittað mejslað stįetigelstie",
  "block.minecraft.infested_cobblestone": "Smittað gatustįe",
  "block.minecraft.infested_cracked_stone_bricks": "Smittað sprutjintigelstie",
  "block.minecraft.infested_deepslate": "Infektirað diuopstjiffer",
  "block.minecraft.infested_mossy_stone_bricks": "Mossug stįetigelstie",
  "block.minecraft.infested_stone": "Smittað stie",
  "block.minecraft.infested_stone_bricks": "Smittað stįetigelstie",
  "block.minecraft.iron_bars": "Ienngalder",
  "block.minecraft.iron_block": "Iennblokk",
  "block.minecraft.iron_chain": "Järnkedja",
  "block.minecraft.iron_door": "Ienndörer",
  "block.minecraft.iron_ore": "Iennmalmsåðer",
  "block.minecraft.iron_trapdoor": "Iennfollukku",
  "block.minecraft.jack_o_lantern": "Lykta, gard ov pumpu",
  "block.minecraft.jigsaw": "Pusselblokk",
  "block.minecraft.jukebox": "Musiklåð",
  "block.minecraft.jungle_button": "Jungelknapp",
  "block.minecraft.jungle_door": "Junggeldörer",
  "block.minecraft.jungle_fence": "Junggelstakiet",
  "block.minecraft.jungle_fence_gate": "Grind i jungelstakiet",
  "block.minecraft.jungle_hanging_sign": "Hängande djungelskylt",
  "block.minecraft.jungle_leaves": "Junggellov",
  "block.minecraft.jungle_log": "Junggelkabb",
  "block.minecraft.jungle_planks": "Djunggelplaunkur",
  "block.minecraft.jungle_pressure_plate": "Junggelpressplatt",
  "block.minecraft.jungle_sapling": "Djunggelplemta",
  "block.minecraft.jungle_shelf": "Djungelhylla",
  "block.minecraft.jungle_sign": "Junggelstjylt",
  "block.minecraft.jungle_slab": "Junggelstjiv",
  "block.minecraft.jungle_stairs": "Junggeltrampur",
  "block.minecraft.jungle_trapdoor": "Junggelluku",
  "block.minecraft.jungle_wall_hanging_sign": "Hängande djungelskylt på vägg",
  "block.minecraft.jungle_wall_sign": "Junggelweggstjylt",
  "block.minecraft.jungle_wood": "Junggelwiðn",
  "block.minecraft.kelp": "Alg",
  "block.minecraft.kelp_plant": "Algplemtur",
  "block.minecraft.ladder": "Stitji",
  "block.minecraft.lantern": "Lykta",
  "block.minecraft.lapis_block": "Blokk åv Lapis Lazuli",
  "block.minecraft.lapis_ore": "Lapis lazuli åðer",
  "block.minecraft.large_amethyst_bud": "Stur ametistknupp",
  "block.minecraft.large_fern": "Sturuormbunk",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavaketil",
  "block.minecraft.leaf_litter": "Lövrester",
  "block.minecraft.lectern": "Kateðer",
  "block.minecraft.lever": "Lunna",
  "block.minecraft.light": "Liuoseð",
  "block.minecraft.light_blue_banner": "Liuosblå fana",
  "block.minecraft.light_blue_bed": "Liuosblå saingg",
  "block.minecraft.light_blue_candle": "Ljuosblått stiarinljuos",
  "block.minecraft.light_blue_candle_cake": "Tårt min liuosblå liuos",
  "block.minecraft.light_blue_carpet": "Liuosblå matta",
  "block.minecraft.light_blue_concrete": "Liuosblå bitongg",
  "block.minecraft.light_blue_concrete_powder": "Liuosblå bitonggpulver",
  "block.minecraft.light_blue_glazed_terracotta": "Ljuosblåglasirað terrakotta",
  "block.minecraft.light_blue_shulker_box": "Liuosblå shulkerlåða",
  "block.minecraft.light_blue_stained_glass": "Ljuosblåflekkaðglas",
  "block.minecraft.light_blue_stained_glass_pane": "Ljuosblåflekkaðglasrut",
  "block.minecraft.light_blue_terracotta": "Ljuosblå terrakotta",
  "block.minecraft.light_blue_wool": "Liuosblå ull",
  "block.minecraft.light_gray_banner": "Liuosgrå fana",
  "block.minecraft.light_gray_bed": "Liuosgrå saingg",
  "block.minecraft.light_gray_candle": "Ljuosgrått stiarinljuos",
  "block.minecraft.light_gray_candle_cake": "Tårt min liuosgrått liuos",
  "block.minecraft.light_gray_carpet": "Liuosgrå matta",
  "block.minecraft.light_gray_concrete": "Liuosgrå bitongg",
  "block.minecraft.light_gray_concrete_powder": "Liuosgrå bitonggpulver",
  "block.minecraft.light_gray_glazed_terracotta": "Syanglasirað terrakotta",
  "block.minecraft.light_gray_shulker_box": "Liuosgrå shulkerlåð",
  "block.minecraft.light_gray_stained_glass": "Ljuosgråflekkaðglas",
  "block.minecraft.light_gray_stained_glass_pane": "Ljuosgråflekkaðglasrut",
  "block.minecraft.light_gray_terracotta": "Ljuosgrå terrakotta",
  "block.minecraft.light_gray_wool": "Liuosgrå ull",
  "block.minecraft.light_weighted_pressure_plate": "Litt pressplatt",
  "block.minecraft.lightning_rod": "Åsklieðer",
  "block.minecraft.lilac": "Syriener",
  "block.minecraft.lily_of_the_valley": "Bukkblaðsbljomm",
  "block.minecraft.lily_pad": "Lerblað",
  "block.minecraft.lime_banner": "Limegryön fana",
  "block.minecraft.lime_bed": "Limegryön saingg",
  "block.minecraft.lime_candle": "Laimfergað stiarinljuos",
  "block.minecraft.lime_candle_cake": "Tårt min laimfergað liuos",
  "block.minecraft.lime_carpet": "Limegryön matta",
  "block.minecraft.lime_concrete": "Limegryön bitongg",
  "block.minecraft.lime_concrete_powder": "Limegryön bitonggpulver",
  "block.minecraft.lime_glazed_terracotta": "Laimfergað glasirað terrakotta",
  "block.minecraft.lime_shulker_box": "Laimfergað shulkerlåð",
  "block.minecraft.lime_stained_glass": "Laimflekkaðglas",
  "block.minecraft.lime_stained_glass_pane": "Kalkflekkaðglasrut",
  "block.minecraft.lime_terracotta": "Limeferagðterrakott",
  "block.minecraft.lime_wool": "Limegryön ull",
  "block.minecraft.lodestone": "Magnetit",
  "block.minecraft.loom": "Wevstuolur",
  "block.minecraft.magenta_banner": "Liuoslila fana",
  "block.minecraft.magenta_bed": "Liuoslila saingg",
  "block.minecraft.magenta_candle": "Magentafergað stiarinljuos",
  "block.minecraft.magenta_candle_cake": "Tårt min lila liuos",
  "block.minecraft.magenta_carpet": "Liuoslila matta",
  "block.minecraft.magenta_concrete": "Liuoslila bitongg",
  "block.minecraft.magenta_concrete_powder": "Liuoslila bitonggpulver",
  "block.minecraft.magenta_glazed_terracotta": "Magentaglasirað terrakotta",
  "block.minecraft.magenta_shulker_box": "Liuoslila shulkerlåða",
  "block.minecraft.magenta_stained_glass": "Magentaflekkaðglas",
  "block.minecraft.magenta_stained_glass_pane": "Magentaflekkaðglasrut",
  "block.minecraft.magenta_terracotta": "Magenta terrakotta",
  "block.minecraft.magenta_wool": "Liuoslila ull",
  "block.minecraft.magma_block": "Magmablokk",
  "block.minecraft.mangrove_button": "Mangroveknapp",
  "block.minecraft.mangrove_door": "Mangrovedörär",
  "block.minecraft.mangrove_fence": "Mangrovestakiet",
  "block.minecraft.mangrove_fence_gate": "Mangrovestakietgrind",
  "block.minecraft.mangrove_hanging_sign": "Hängande mangroveskylt",
  "block.minecraft.mangrove_leaves": "Mangrovelover",
  "block.minecraft.mangrove_log": "Mangrovekabbe",
  "block.minecraft.mangrove_planks": "Mangroveplaunkur",
  "block.minecraft.mangrove_pressure_plate": "Trykkplatt ov Mangrove",
  "block.minecraft.mangrove_propagule": "Mangrovestrott",
  "block.minecraft.mangrove_roots": "Mangroveruotur",
  "block.minecraft.mangrove_shelf": "Mangrovehylla",
  "block.minecraft.mangrove_sign": "Mangrovestjylt",
  "block.minecraft.mangrove_slab": "Mangrovestjiv",
  "block.minecraft.mangrove_stairs": "Mangrovetrampur",
  "block.minecraft.mangrove_trapdoor": "Mangrove-fallukka",
  "block.minecraft.mangrove_wall_hanging_sign": "Hängande mangroveskylt på vägg",
  "block.minecraft.mangrove_wall_sign": "Mangroveweggstjylt",
  "block.minecraft.mangrove_wood": "Mangroveyrtje",
  "block.minecraft.medium_amethyst_bud": "Millostur ametistknupp",
  "block.minecraft.melon": "Meluon",
  "block.minecraft.melon_stem": "Melonstiuok",
  "block.minecraft.moss_block": "Muossblokk",
  "block.minecraft.moss_carpet": "Muossmatt",
  "block.minecraft.mossy_cobblestone": "Muossun gatustie",
  "block.minecraft.mossy_cobblestone_slab": "Muosun gatustiestjiv",
  "block.minecraft.mossy_cobblestone_stairs": "Mossug gatustįetrampur",
  "block.minecraft.mossy_cobblestone_wall": "Mossug gatustįewegg",
  "block.minecraft.mossy_stone_brick_slab": "Mossun stietigelstįestjiv",
  "block.minecraft.mossy_stone_brick_stairs": "Mossug tigelstįetrampur",
  "block.minecraft.mossy_stone_brick_wall": "Muossun stįetigelstįewegg",
  "block.minecraft.mossy_stone_bricks": "Mossun stįetigelstie",
  "block.minecraft.moving_piston": "Brägend kolv",
  "block.minecraft.mud": "Liera",
  "block.minecraft.mud_brick_slab": "Liertigelstjiv",
  "block.minecraft.mud_brick_stairs": "Liertigeltrampur",
  "block.minecraft.mud_brick_wall": "Liertiigelmuor",
  "block.minecraft.mud_bricks": "Liertigelstiener",
  "block.minecraft.muddy_mangrove_roots": "Lierug mangroveruotur",
  "block.minecraft.mushroom_stem": "Soppstjälk",
  "block.minecraft.mycelium": "Mysel",
  "block.minecraft.nether_brick_fence": "Nethertigelstįestakiet",
  "block.minecraft.nether_brick_slab": "Nethertigelstjiv",
  "block.minecraft.nether_brick_stairs": "Nethertigelstįetrampur",
  "block.minecraft.nether_brick_wall": "Nethertigelstįewegg",
  "block.minecraft.nether_bricks": "Nethertigelstiener",
  "block.minecraft.nether_gold_ore": "Nethergullåðer",
  "block.minecraft.nether_portal": "Netherportal",
  "block.minecraft.nether_quartz_ore": "Netherkwartsåðer",
  "block.minecraft.nether_sprouts": "Nethernylaðir",
  "block.minecraft.nether_wart": "Neðerwart",
  "block.minecraft.nether_wart_block": "Netherwårtblokk",
  "block.minecraft.netherite_block": "Blokk ov netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Meddielendblokk",
  "block.minecraft.oak_button": "Iekknapp",
  "block.minecraft.oak_door": "Iekdörer",
  "block.minecraft.oak_fence": "Iekstakiet",
  "block.minecraft.oak_fence_gate": "Grind i iekstakiet",
  "block.minecraft.oak_hanging_sign": "Hängande ekskylt",
  "block.minecraft.oak_leaves": "Ieklov",
  "block.minecraft.oak_log": "Iekkabb",
  "block.minecraft.oak_planks": "Iekplaunkur",
  "block.minecraft.oak_pressure_plate": "Iekpressplatt",
  "block.minecraft.oak_sapling": "Iekplemta",
  "block.minecraft.oak_shelf": "Ekhylla",
  "block.minecraft.oak_sign": "Iekstjylt",
  "block.minecraft.oak_slab": "Iekstjiv",
  "block.minecraft.oak_stairs": "Iektrampur",
  "block.minecraft.oak_trapdoor": "Iekfollukku",
  "block.minecraft.oak_wall_hanging_sign": "Hängande ekskylt på vägg",
  "block.minecraft.oak_wall_sign": "Iekweggstjylt",
  "block.minecraft.oak_wood": "Iekwiðn",
  "block.minecraft.observer": "Observatör",
  "block.minecraft.obsidian": "Obsiðan",
  "block.minecraft.ochre_froglight": "Okkrafergað tuoskliuos",
  "block.minecraft.ominous_banner": "Uotend fana",
  "block.minecraft.open_eyeblossom": "Öppen ögonblomma",
  "block.minecraft.orange_banner": "Guolroð fana",
  "block.minecraft.orange_bed": "Guolroð saingg",
  "block.minecraft.orange_candle": "Brandguol stiarinljuos",
  "block.minecraft.orange_candle_cake": "Tårt min brandguolų ljuos",
  "block.minecraft.orange_carpet": "Guolroð matta",
  "block.minecraft.orange_concrete": "Guolroð bitongg",
  "block.minecraft.orange_concrete_powder": "Guolroð bitonggpulver",
  "block.minecraft.orange_glazed_terracotta": "Orangeglasirað terrakotta",
  "block.minecraft.orange_shulker_box": "Guolroð shulkerlåða",
  "block.minecraft.orange_stained_glass": "Orandjflekkaðglas",
  "block.minecraft.orange_stained_glass_pane": "Orandjflekkaðglasrut",
  "block.minecraft.orange_terracotta": "Guolroð terrakotta",
  "block.minecraft.orange_tulip": "Guolroð tulpan",
  "block.minecraft.orange_wool": "Guolroð ull",
  "block.minecraft.oxeye_daisy": "Waitkull",
  "block.minecraft.oxidized_chiseled_copper": "Oksiðirað mejslað kuppär",
  "block.minecraft.oxidized_copper": "Kuppärn so ar rostað",
  "block.minecraft.oxidized_copper_bars": "Ärgat koppargaller",
  "block.minecraft.oxidized_copper_bulb": "Oksiðirað kuppärlampel",
  "block.minecraft.oxidized_copper_chain": "Ärgad kopparkedja",
  "block.minecraft.oxidized_copper_chest": "Ärgad kopparkista",
  "block.minecraft.oxidized_copper_door": "Oksiðirað kuppärdörr",
  "block.minecraft.oxidized_copper_golem_statue": "Ärgad koppargolemstaty",
  "block.minecraft.oxidized_copper_grate": "Oksiðirað kuppärgaller",
  "block.minecraft.oxidized_copper_lantern": "Ärgad kopparlykta",
  "block.minecraft.oxidized_copper_trapdoor": "Oksiðirað kuppärfollukku",
  "block.minecraft.oxidized_cut_copper": "Oksiðirað skurin kupär",
  "block.minecraft.oxidized_cut_copper_slab": "Oksiðirað skurin kupärstjiv",
  "block.minecraft.oxidized_cut_copper_stairs": "Oksiðirað trampur ov skurin kupär",
  "block.minecraft.oxidized_lightning_rod": "Ärgad åskledare",
  "block.minecraft.packed_ice": "Pakkað ais",
  "block.minecraft.packed_mud": "Pað liera",
  "block.minecraft.pale_hanging_moss": "Hängande blek mossa",
  "block.minecraft.pale_moss_block": "Blekt mossblock",
  "block.minecraft.pale_moss_carpet": "Blek mossmatta",
  "block.minecraft.pale_oak_button": "Blek ekknapp",
  "block.minecraft.pale_oak_door": "Blek ekdörr",
  "block.minecraft.pale_oak_fence": "Blekt ekstaket",
  "block.minecraft.pale_oak_fence_gate": "Blek ekgrind",
  "block.minecraft.pale_oak_hanging_sign": "Hängande blek ekskylt",
  "block.minecraft.pale_oak_leaves": "Bleka eklöv",
  "block.minecraft.pale_oak_log": "Blek ekstam",
  "block.minecraft.pale_oak_planks": "Bleka ekplankor",
  "block.minecraft.pale_oak_pressure_plate": "Blek ektryckplatta",
  "block.minecraft.pale_oak_sapling": "Blek ekplanta",
  "block.minecraft.pale_oak_shelf": "Blek ekhylla",
  "block.minecraft.pale_oak_sign": "Blek ekskylt",
  "block.minecraft.pale_oak_slab": "Blek ekplatta",
  "block.minecraft.pale_oak_stairs": "Blek ektrappa",
  "block.minecraft.pale_oak_trapdoor": "Blek ekfallucka",
  "block.minecraft.pale_oak_wall_hanging_sign": "Hängande blek ekskylt på vägg",
  "block.minecraft.pale_oak_wall_sign": "Blek ekskylt på vägg",
  "block.minecraft.pale_oak_wood": "Blekt ekträ",
  "block.minecraft.pearlescent_froglight": "Pärlemorlysend tuoskliuos",
  "block.minecraft.peony": "Piuon",
  "block.minecraft.petrified_oak_slab": "Ferstienaðiekstjiv",
  "block.minecraft.piglin_head": "Piglinhuvud",
  "block.minecraft.piglin_wall_head": "Piglinhuvud på vägg",
  "block.minecraft.pink_banner": "Stjär fana",
  "block.minecraft.pink_bed": "Stjär saingg",
  "block.minecraft.pink_candle": "Stjärt stiarinljuos",
  "block.minecraft.pink_candle_cake": "Tårt min rosa liuos",
  "block.minecraft.pink_carpet": "Rosa matta",
  "block.minecraft.pink_concrete": "Råsa bitongg",
  "block.minecraft.pink_concrete_powder": "Råsa bitonggpulver",
  "block.minecraft.pink_glazed_terracotta": "Stjärglasirað terrakotta",
  "block.minecraft.pink_petals": "Rosa kronblad",
  "block.minecraft.pink_shulker_box": "Stjär shulkerlåða",
  "block.minecraft.pink_stained_glass": "Stjärflekkaðglas",
  "block.minecraft.pink_stained_glass_pane": "Stjärflekkaðglasrut",
  "block.minecraft.pink_terracotta": "Stjär terrakotta",
  "block.minecraft.pink_tulip": "Rosatulpan",
  "block.minecraft.pink_wool": "Rosa ull",
  "block.minecraft.piston": "Kolv",
  "block.minecraft.piston_head": "Kolvovuð",
  "block.minecraft.pitcher_crop": "Kannrįestiena",
  "block.minecraft.pitcher_plant": "Kannrįes",
  "block.minecraft.player_head": "Spilerovuð",
  "block.minecraft.player_head.named": "%ss skolle ",
  "block.minecraft.player_wall_head": "Spilerweggskoll",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Spitsun druppstien",
  "block.minecraft.polished_andesite": "Polirað andesit",
  "block.minecraft.polished_andesite_slab": "Polirað andesitstjiv",
  "block.minecraft.polished_andesite_stairs": "Poliraðer andesittrampur",
  "block.minecraft.polished_basalt": "Polirað basalt",
  "block.minecraft.polished_blackstone": "Polirað swartstien",
  "block.minecraft.polished_blackstone_brick_slab": "Stjiv ov polirað swartstįestiener",
  "block.minecraft.polished_blackstone_brick_stairs": "Trampur ov polirað swartstįestiener",
  "block.minecraft.polished_blackstone_brick_wall": "Muor ov poliraðer swartstįestiener",
  "block.minecraft.polished_blackstone_bricks": "Poliraðer swartstįestiener",
  "block.minecraft.polished_blackstone_button": "Polirað swartstįeknapp",
  "block.minecraft.polished_blackstone_pressure_plate": "Poilirað trykkplatt ov swartstien",
  "block.minecraft.polished_blackstone_slab": "Polirað stjiv ov swartstien",
  "block.minecraft.polished_blackstone_stairs": "Polirað trampur ov swartstien",
  "block.minecraft.polished_blackstone_wall": "Polirað muor ov swartstien",
  "block.minecraft.polished_deepslate": "Polirað djiuostjiffer",
  "block.minecraft.polished_deepslate_slab": "Polirað diuopstjifferplatta",
  "block.minecraft.polished_deepslate_stairs": "Trampur åv diuopstjiffer",
  "block.minecraft.polished_deepslate_wall": "Polirað muor åv diuopstjiffer",
  "block.minecraft.polished_diorite": "Polirað dorit",
  "block.minecraft.polished_diorite_slab": "Polirað dioritstjiv",
  "block.minecraft.polished_diorite_stairs": "Poliraðer diorittrampur",
  "block.minecraft.polished_granite": "Pulirað granit",
  "block.minecraft.polished_granite_slab": "Polirað granitstjiv",
  "block.minecraft.polished_granite_stairs": "Poliraðer granittrampur",
  "block.minecraft.polished_tuff": "Polirað tuff",
  "block.minecraft.polished_tuff_slab": "Polirað tuffplatta",
  "block.minecraft.polished_tuff_stairs": "Polirað tufftrampur",
  "block.minecraft.polished_tuff_wall": "Polirað tuffwegg",
  "block.minecraft.poppy": "Wallmuo",
  "block.minecraft.potatoes": "Pärur",
  "block.minecraft.potted_acacia_sapling": "Akasiaplemt i kruku",
  "block.minecraft.potted_allium": "Graslok i kruku",
  "block.minecraft.potted_azalea_bush": "Asalea i kruku",
  "block.minecraft.potted_azure_bluet": "Posslinsstienn i kruku",
  "block.minecraft.potted_bamboo": "Bambu i kruku",
  "block.minecraft.potted_birch_sapling": "Byörkplemt i kruku",
  "block.minecraft.potted_blue_orchid": "Blå uortjiði i kruku",
  "block.minecraft.potted_brown_mushroom": "Brunsopp i kruku",
  "block.minecraft.potted_cactus": "Kaktus i kruku",
  "block.minecraft.potted_cherry_sapling": "Körsbärsplanta i kruka",
  "block.minecraft.potted_closed_eyeblossom": "Stängd ögonblomma i kruka",
  "block.minecraft.potted_cornflower": "Rugbljomm i kruku",
  "block.minecraft.potted_crimson_fungus": "Mörkroð sopp i kruku",
  "block.minecraft.potted_crimson_roots": "Mörkroð ruotur i kruku",
  "block.minecraft.potted_dandelion": "Smyörbljuomm i kruku",
  "block.minecraft.potted_dark_oak_sapling": "Mörkiekplemt i kruku",
  "block.minecraft.potted_dead_bush": "Dod buosk i kruku",
  "block.minecraft.potted_fern": "Uormbunk i kruku",
  "block.minecraft.potted_flowering_azalea_bush": "Asalea so bljuommer i kruku",
  "block.minecraft.potted_golden_dandelion": "Gyllene maskros i kruka",
  "block.minecraft.potted_jungle_sapling": "Junggelplemt i kruku",
  "block.minecraft.potted_lily_of_the_valley": "Bukkblad i kruku",
  "block.minecraft.potted_mangrove_propagule": "Mangrovestrott i kruku",
  "block.minecraft.potted_oak_sapling": "Iekplemt i kruku",
  "block.minecraft.potted_open_eyeblossom": "Öppen ögonblomma i kruka",
  "block.minecraft.potted_orange_tulip": "Guolroð tulpan i kruku",
  "block.minecraft.potted_oxeye_daisy": "Waitkull i kruku",
  "block.minecraft.potted_pale_oak_sapling": "Blek ekplanta i kruka",
  "block.minecraft.potted_pink_tulip": "Rosa tulpan i kruku",
  "block.minecraft.potted_poppy": "Wallmobljuomm i kruku",
  "block.minecraft.potted_red_mushroom": "Roðsopp i kruku",
  "block.minecraft.potted_red_tulip": "Roðtulpan i kruku",
  "block.minecraft.potted_spruce_sapling": "Gråplemt i kruku",
  "block.minecraft.potted_torchflower": "Fackellilja i kruka",
  "block.minecraft.potted_warped_fungus": "Fevrengd sopp i kruku",
  "block.minecraft.potted_warped_roots": "Fevrengd routur i kruku",
  "block.minecraft.potted_white_tulip": "Waittulpan i kruku",
  "block.minecraft.potted_wither_rose": "Wissnaðruos i kruku",
  "block.minecraft.powder_snow": "Puðersniuon",
  "block.minecraft.powder_snow_cauldron": "Ketil fer puðersniuon",
  "block.minecraft.powered_rail": "Rels min kraft",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Prismarintigelstjiv",
  "block.minecraft.prismarine_brick_stairs": "Prismarin tigeltrampur",
  "block.minecraft.prismarine_bricks": "Prismarin tigelstiener",
  "block.minecraft.prismarine_slab": "Prismarinstjiv",
  "block.minecraft.prismarine_stairs": "Prismarintrampur",
  "block.minecraft.prismarine_wall": "Prismarinwegg",
  "block.minecraft.pumpkin": "Pumpa",
  "block.minecraft.pumpkin_stem": "Pumpstiuok",
  "block.minecraft.purple_banner": "Lila fana",
  "block.minecraft.purple_bed": "Lila saingg",
  "block.minecraft.purple_candle": "Lila stiarinljuos",
  "block.minecraft.purple_candle_cake": "Tårt min lila liuos",
  "block.minecraft.purple_carpet": "Lila matta",
  "block.minecraft.purple_concrete": "Lila bitongg",
  "block.minecraft.purple_concrete_powder": "Lila bitonggpulver",
  "block.minecraft.purple_glazed_terracotta": "Purpurglasirad terrakotta",
  "block.minecraft.purple_shulker_box": "Lila shulkerlåð",
  "block.minecraft.purple_stained_glass": "Lilaflekkaðglas",
  "block.minecraft.purple_stained_glass_pane": "Lilaflekkaðglasrut",
  "block.minecraft.purple_terracotta": "Lila terrakotta",
  "block.minecraft.purple_wool": "Lila ull",
  "block.minecraft.purpur_block": "Purpurblokk",
  "block.minecraft.purpur_pillar": "Purpurpiler",
  "block.minecraft.purpur_slab": "Purpurstjiv",
  "block.minecraft.purpur_stairs": "Purpurtrampur",
  "block.minecraft.quartz_block": "Kwartsblokk",
  "block.minecraft.quartz_bricks": "Tigelstiener ov kwarts",
  "block.minecraft.quartz_pillar": "Kwartspiler",
  "block.minecraft.quartz_slab": "Kwartsstjiv",
  "block.minecraft.quartz_stairs": "Kwartstrampur",
  "block.minecraft.rail": "Rels",
  "block.minecraft.raw_copper_block": "Råkuppärblokk",
  "block.minecraft.raw_gold_block": "Rågullblokk",
  "block.minecraft.raw_iron_block": "Råiennblokk",
  "block.minecraft.red_banner": "Roð fana",
  "block.minecraft.red_bed": "Roð saingg",
  "block.minecraft.red_candle": "Rott stiarinljuos",
  "block.minecraft.red_candle_cake": "Tårt min roð ljuos",
  "block.minecraft.red_carpet": "Roð matta",
  "block.minecraft.red_concrete": "Roð bitongg",
  "block.minecraft.red_concrete_powder": "Roð bitonggpulver",
  "block.minecraft.red_glazed_terracotta": "Roðglasirað terrakotta",
  "block.minecraft.red_mushroom": "Roðsopp",
  "block.minecraft.red_mushroom_block": "Roð soppblokk",
  "block.minecraft.red_nether_brick_slab": "Rod nethertigelstįestjiv",
  "block.minecraft.red_nether_brick_stairs": "Roðu Nethertigelstįetrampur",
  "block.minecraft.red_nether_brick_wall": "Roð nethertigelstįewegg",
  "block.minecraft.red_nether_bricks": "Roð Nethertigelstiener",
  "block.minecraft.red_sand": "Roðsandn",
  "block.minecraft.red_sandstone": "Roðsandstie",
  "block.minecraft.red_sandstone_slab": "Roðsandstiestiv",
  "block.minecraft.red_sandstone_stairs": "Roðsandstįetrampur",
  "block.minecraft.red_sandstone_wall": "Roð sandstįewegg",
  "block.minecraft.red_shulker_box": "Roð shulkerlåð",
  "block.minecraft.red_stained_glass": "Roðflekkaðglas",
  "block.minecraft.red_stained_glass_pane": "Rodflekkaðglasrut",
  "block.minecraft.red_terracotta": "Roð terrakotta",
  "block.minecraft.red_tulip": "Roðtulpan",
  "block.minecraft.red_wool": "Roð ull",
  "block.minecraft.redstone_block": "Redstoneblokk",
  "block.minecraft.redstone_lamp": "Redstonelampa",
  "block.minecraft.redstone_ore": "Redstoneåðer",
  "block.minecraft.redstone_torch": "Redstonestikkliuos",
  "block.minecraft.redstone_wall_torch": "Redstoneweggstikkljuos",
  "block.minecraft.redstone_wire": "Redstonetråð",
  "block.minecraft.reinforced_deepslate": "Försterkt djuopstjiffer",
  "block.minecraft.repeater": "Redstonestutterer",
  "block.minecraft.repeating_command_block": "Repetirend kommandoblokk",
  "block.minecraft.resin_block": "Hartsblock",
  "block.minecraft.resin_brick_slab": "Hartstegelplatta",
  "block.minecraft.resin_brick_stairs": "Hartstegeltrappa",
  "block.minecraft.resin_brick_wall": "Hartstegelmur",
  "block.minecraft.resin_bricks": "Hartstegel",
  "block.minecraft.resin_clump": "Hartsklump",
  "block.minecraft.respawn_anchor": "Anker för återupplivningg",
  "block.minecraft.rooted_dirt": "Ruotaðmulldn",
  "block.minecraft.rose_bush": "Ruosbuosk",
  "block.minecraft.sand": "Sandn",
  "block.minecraft.sandstone": "Sandstie",
  "block.minecraft.sandstone_slab": "Sandstiestjiv",
  "block.minecraft.sandstone_stairs": "Sandstįetrampur",
  "block.minecraft.sandstone_wall": "Sanstįewegg",
  "block.minecraft.scaffolding": "Byggstellningg",
  "block.minecraft.sculk": "Skulk",
  "block.minecraft.sculk_catalyst": "Skulkkatalysator",
  "block.minecraft.sculk_sensor": "Sculkupptekker",
  "block.minecraft.sculk_shrieker": "Skulkremer",
  "block.minecraft.sculk_vein": "Skulkven",
  "block.minecraft.sea_lantern": "Sjulantern",
  "block.minecraft.sea_pickle": "Sjugurka",
  "block.minecraft.seagrass": "Sjugras",
  "block.minecraft.set_spawn": "Återupplivninggspunkt bistemmd",
  "block.minecraft.short_dry_grass": "Kort torrt gräs",
  "block.minecraft.short_grass": "Stuttgraseð",
  "block.minecraft.shroomlight": "Shroomliuos",
  "block.minecraft.shulker_box": "Shulkerlåð",
  "block.minecraft.skeleton_skull": "Skelettskoll",
  "block.minecraft.skeleton_wall_skull": "Skelettweggskoll",
  "block.minecraft.slime_block": "Kliemblokk",
  "block.minecraft.small_amethyst_bud": "Litn ametistknupp",
  "block.minecraft.small_dripleaf": "Små druplover",
  "block.minecraft.smithing_table": "Smiðbuord",
  "block.minecraft.smoker": "Rätjungen",
  "block.minecraft.smooth_basalt": "Blotbasalt",
  "block.minecraft.smooth_quartz": "Blot kwartsstjiv",
  "block.minecraft.smooth_quartz_slab": "Blot kwartsstjiv",
  "block.minecraft.smooth_quartz_stairs": "Blot kwartstrampur",
  "block.minecraft.smooth_red_sandstone": "Blotroðsandstie",
  "block.minecraft.smooth_red_sandstone_slab": "Blot roð sandstįestjiv",
  "block.minecraft.smooth_red_sandstone_stairs": "Blot roðsandstįetrampur",
  "block.minecraft.smooth_sandstone": "Blotsandstie",
  "block.minecraft.smooth_sandstone_slab": "Blot sandstįestjiv",
  "block.minecraft.smooth_sandstone_stairs": "Blot sandstįetrampur",
  "block.minecraft.smooth_stone": "Blotstie",
  "block.minecraft.smooth_stone_slab": "Blotstiestjiv",
  "block.minecraft.sniffer_egg": "Snuseregg",
  "block.minecraft.snow": "Sniųo",
  "block.minecraft.snow_block": "Sniųoblokk",
  "block.minecraft.soul_campfire": "Själsjäldn",
  "block.minecraft.soul_fire": "Själsjäldn",
  "block.minecraft.soul_lantern": "Själsllykta",
  "block.minecraft.soul_sand": "Själsand",
  "block.minecraft.soul_soil": "Själsmulld",
  "block.minecraft.soul_torch": "Själsstikkliuos",
  "block.minecraft.soul_wall_torch": "Själsweggstikkliuos",
  "block.minecraft.spawn.not_valid": "Du ar it ingg iemsaingg elld standuppanker, elld og ir eð festört",
  "block.minecraft.spawner": "Monsterskapare",
  "block.minecraft.spawner.desc1": "Interaktion med skapelseägg:",
  "block.minecraft.spawner.desc2": "Ändrar varelsetypen",
  "block.minecraft.sponge": "Twåsopp",
  "block.minecraft.spore_blossom": "Sporbljomningg",
  "block.minecraft.spruce_button": "Grǫknapp",
  "block.minecraft.spruce_door": "Grą̊dörer",
  "block.minecraft.spruce_fence": "Grǫstakiet",
  "block.minecraft.spruce_fence_gate": "Grind i grą̊stakiet",
  "block.minecraft.spruce_hanging_sign": "Hängande granskylt",
  "block.minecraft.spruce_leaves": "Grǫbårnǫler",
  "block.minecraft.spruce_log": "Grǫkabb",
  "block.minecraft.spruce_planks": "Grą̊plaunkur",
  "block.minecraft.spruce_pressure_plate": "Grǫpressplant",
  "block.minecraft.spruce_sapling": "Grǫplemta",
  "block.minecraft.spruce_shelf": "Granhylla",
  "block.minecraft.spruce_sign": "Grǫstşylt",
  "block.minecraft.spruce_slab": "Gråstjiv",
  "block.minecraft.spruce_stairs": "Grǫtrampur",
  "block.minecraft.spruce_trapdoor": "Grą̊follukku",
  "block.minecraft.spruce_wall_hanging_sign": "Hängande granskylt på vägg",
  "block.minecraft.spruce_wall_sign": "Grǫweggstjylt",
  "block.minecraft.spruce_wood": "Grǫwiðn",
  "block.minecraft.sticky_piston": "Kliemun kolv",
  "block.minecraft.stone": "Stie",
  "block.minecraft.stone_brick_slab": "Stietigelstjiv",
  "block.minecraft.stone_brick_stairs": "Stįetigelstietrampur",
  "block.minecraft.stone_brick_wall": "Stįetigelstįewegg",
  "block.minecraft.stone_bricks": "Stįetigelstie",
  "block.minecraft.stone_button": "Stįeknapp",
  "block.minecraft.stone_pressure_plate": "Stįepressplatt",
  "block.minecraft.stone_slab": "Stiestjiv",
  "block.minecraft.stone_stairs": "Stįetrampur",
  "block.minecraft.stonecutter": "Stiestjärer",
  "block.minecraft.stripped_acacia_log": "Barkað akasiakabb",
  "block.minecraft.stripped_acacia_wood": "Barkað akasiawiðn",
  "block.minecraft.stripped_bamboo_block": "Avskalat bambublock",
  "block.minecraft.stripped_birch_log": "Barkað byörkkabb",
  "block.minecraft.stripped_birch_wood": "Barkað byörkwiðn",
  "block.minecraft.stripped_cherry_log": "Avbarkad körsbärsstam",
  "block.minecraft.stripped_cherry_wood": "Avbarkat körsbärsträ",
  "block.minecraft.stripped_crimson_hyphae": "Åvbarkaðer karmosinhyfer",
  "block.minecraft.stripped_crimson_stem": "Åvbarkað karmosinstam",
  "block.minecraft.stripped_dark_oak_log": "Barkað mörkiekkabb",
  "block.minecraft.stripped_dark_oak_wood": "Barkað mörkiekwiðn",
  "block.minecraft.stripped_jungle_log": "Barkað junggelkabb",
  "block.minecraft.stripped_jungle_wood": "Barkað junggelwiðn",
  "block.minecraft.stripped_mangrove_log": "Barkað mangrovekabb",
  "block.minecraft.stripped_mangrove_wood": "Barkað magrovyrtje",
  "block.minecraft.stripped_oak_log": "Barkað iekkabb",
  "block.minecraft.stripped_oak_wood": "Barkað iekwiðn",
  "block.minecraft.stripped_pale_oak_log": "Avbarkad blek ekstam",
  "block.minecraft.stripped_pale_oak_wood": "Avbarkat blekt ekträ",
  "block.minecraft.stripped_spruce_log": "Barkað grǫkabb",
  "block.minecraft.stripped_spruce_wood": "Barkað grǫwiðn",
  "block.minecraft.stripped_warped_hyphae": "Åvbarkað fevränggd yf",
  "block.minecraft.stripped_warped_stem": "Åvbarkað fevränggd stam",
  "block.minecraft.structure_block": "Strukturblokk",
  "block.minecraft.structure_void": "Stukrturtuomruom",
  "block.minecraft.sugar_cane": "Sokkerrör",
  "block.minecraft.sunflower": "Suolruos",
  "block.minecraft.suspicious_gravel": "Misstainkt grus",
  "block.minecraft.suspicious_sand": "Misstänksam sand",
  "block.minecraft.sweet_berry_bush": "Syötberbuosk",
  "block.minecraft.tall_dry_grass": "Högt torrt gräs",
  "block.minecraft.tall_grass": "Launggras",
  "block.minecraft.tall_seagrass": "Langgt sjugras",
  "block.minecraft.target": "Mǫl",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Testblock",
  "block.minecraft.test_instance_block": "Testinstansblock",
  "block.minecraft.tinted_glass": "Tonaðglas",
  "block.minecraft.tnt": "Dynamit",
  "block.minecraft.tnt.disabled": "Dynamitexplosioner är inaktiverade",
  "block.minecraft.torch": "Stikkliuos",
  "block.minecraft.torchflower": "Fackellilja",
  "block.minecraft.torchflower_crop": "Fackelliljeplanta",
  "block.minecraft.trapped_chest": "Instainggd tjist",
  "block.minecraft.trial_spawner": "Utmaningsskapare",
  "block.minecraft.tripwire": "Styppeltråð",
  "block.minecraft.tripwire_hook": "Styppeltråðkruok",
  "block.minecraft.tube_coral": "Rörkorall",
  "block.minecraft.tube_coral_block": "Rörkorallblokk",
  "block.minecraft.tube_coral_fan": "Rörkorallflekt",
  "block.minecraft.tube_coral_wall_fan": "Rörkorallsväggflekt",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Platt åv tufftigelstiener",
  "block.minecraft.tuff_brick_stairs": "Tufftiegelstientrampur",
  "block.minecraft.tuff_brick_wall": "Tufftiegelstienwegg",
  "block.minecraft.tuff_bricks": "Tufftigelstiener",
  "block.minecraft.tuff_slab": "Tuffplatta",
  "block.minecraft.tuff_stairs": "Tufftrampur",
  "block.minecraft.tuff_wall": "Tuffwegg",
  "block.minecraft.turtle_egg": "Stjöldkluossegg",
  "block.minecraft.twisting_vines": "Rwaiðend kleðerwekst",
  "block.minecraft.twisting_vines_plant": "Rwaiðend kleðervekstplemptur",
  "block.minecraft.vault": "Kassaskåp",
  "block.minecraft.verdant_froglight": "Gryönskend tuoskliuos",
  "block.minecraft.vine": "Kleðerwekst",
  "block.minecraft.void_air": "Tuomweðreð",
  "block.minecraft.wall_torch": "Weggstikkljuos",
  "block.minecraft.warped_button": "Fevrengd knapp",
  "block.minecraft.warped_door": "Fevrengd dörer",
  "block.minecraft.warped_fence": "Fevrängt stakiet",
  "block.minecraft.warped_fence_gate": "Fevrengd grind",
  "block.minecraft.warped_fungus": "Fevrängd sopp",
  "block.minecraft.warped_hanging_sign": "Hängande förvrängd skylt",
  "block.minecraft.warped_hyphae": "Fevrängd yfer",
  "block.minecraft.warped_nylium": "Förvrängd nylium",
  "block.minecraft.warped_planks": "Fevrängd plaunkur",
  "block.minecraft.warped_pressure_plate": "Fevrängd trykkstjiv",
  "block.minecraft.warped_roots": "Fervrängd ruotur",
  "block.minecraft.warped_shelf": "Förvrängd hylla",
  "block.minecraft.warped_sign": "Fevrengd stjylt",
  "block.minecraft.warped_slab": "Fevrängd stjiva",
  "block.minecraft.warped_stairs": "Fevrengd trampur",
  "block.minecraft.warped_stem": "Fervrängd stam",
  "block.minecraft.warped_trapdoor": "Fevrengd follukku",
  "block.minecraft.warped_wall_hanging_sign": "Hängande förvrängd skylt på vägg",
  "block.minecraft.warped_wall_sign": "Fewrainggd weggstjylt",
  "block.minecraft.warped_wart_block": "Neðerwartblokk",
  "block.minecraft.water": "Wattn",
  "block.minecraft.water_cauldron": "Watuketil",
  "block.minecraft.waxed_chiseled_copper": "Waksað mejslað kuppär",
  "block.minecraft.waxed_copper_bars": "Vaxat koppargaller",
  "block.minecraft.waxed_copper_block": "Kuppärblokk so ir waksað",
  "block.minecraft.waxed_copper_bulb": "Waksað kuppärlampel",
  "block.minecraft.waxed_copper_chain": "Vaxad kopparkedja",
  "block.minecraft.waxed_copper_chest": "Vaxad kopparkista",
  "block.minecraft.waxed_copper_door": "Waksað oksiðirað kuppärdörr",
  "block.minecraft.waxed_copper_golem_statue": "Vaxad koppargolemstaty",
  "block.minecraft.waxed_copper_grate": "Waksað kuppärgaller",
  "block.minecraft.waxed_copper_lantern": "Vaxad kopparlykta",
  "block.minecraft.waxed_copper_trapdoor": "Waksað kuppärfollukku",
  "block.minecraft.waxed_cut_copper": "Waksað skurin kuppär",
  "block.minecraft.waxed_cut_copper_slab": "Waksað skurin kupperstjiv",
  "block.minecraft.waxed_cut_copper_stairs": "Waksaðer kuppärtrampur",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waksað eksponirað mejslað kuppär",
  "block.minecraft.waxed_exposed_copper": "Waksað eksponiaraðkupär",
  "block.minecraft.waxed_exposed_copper_bars": "Vaxat exponerat koppargaller",
  "block.minecraft.waxed_exposed_copper_bulb": "Waksað eksponirað kuppärlampel",
  "block.minecraft.waxed_exposed_copper_chain": "Vaxad exponerad kopparkedja",
  "block.minecraft.waxed_exposed_copper_chest": "Vaxad exponerad kopparkista",
  "block.minecraft.waxed_exposed_copper_door": "Waksað eksponirað kuppärdörr",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vaxad exponerad koppargolemstaty",
  "block.minecraft.waxed_exposed_copper_grate": "Waksað eksponirað kuppärgaller",
  "block.minecraft.waxed_exposed_copper_lantern": "Vaxad exponerad kopparlykta",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waksað eksponirað kuppärfollukku",
  "block.minecraft.waxed_exposed_cut_copper": "Waksað eksponirað skurin kupär",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Waksað eksponirað skurin kupärstjiv",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Waksað eksponirað kupärtrampur",
  "block.minecraft.waxed_exposed_lightning_rod": "Vaxad exponerad åskledare",
  "block.minecraft.waxed_lightning_rod": "Vaxad åskledare",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waksað oksiðirað mejslað kuppär",
  "block.minecraft.waxed_oxidized_copper": "Waksað oksiðraðkupär",
  "block.minecraft.waxed_oxidized_copper_bars": "Vaxat ärgat koppargaller",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waksað oksiðirað kuppärlampel",
  "block.minecraft.waxed_oxidized_copper_chain": "Vaxad ärgad kopparkedja",
  "block.minecraft.waxed_oxidized_copper_chest": "Vaxad ärgad kopparkista",
  "block.minecraft.waxed_oxidized_copper_door": "Waksað oksiðirað kuppärdörr",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vaxad ärgad koppargolemstaty",
  "block.minecraft.waxed_oxidized_copper_grate": "Waksað oksiðirað kuppärgaller",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vaxad ärgad kopparlykta",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waksað oksiðirað kuppärfollukku",
  "block.minecraft.waxed_oxidized_cut_copper": "Skurin waksað oksiðiraðkuppär",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Waksað oksiðirað skurin kuppärstjiv",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Skurin waksað oksiðiraðkuppärtrampur",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vaxad ärgad åskledare",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waksað weðerne´tt mejslað kuppär",
  "block.minecraft.waxed_weathered_copper": "Wederne´tt waksað kuppär",
  "block.minecraft.waxed_weathered_copper_bars": "Vaxat väderbitet koppargaller",
  "block.minecraft.waxed_weathered_copper_bulb": "Waksað weðerne´tt kuppärlampel",
  "block.minecraft.waxed_weathered_copper_chain": "Vaxad väderbiten kopparkedja",
  "block.minecraft.waxed_weathered_copper_chest": "Vaxad väderbiten kopparkista",
  "block.minecraft.waxed_weathered_copper_door": "Waksað weðerne´tt kuppärdörr",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vaxad väderbiten koppargolemstaty",
  "block.minecraft.waxed_weathered_copper_grate": "Waksað weðerne´tt kuppärgaller",
  "block.minecraft.waxed_weathered_copper_lantern": "Vaxad väderbiten kopparlykta",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waksað weðerne´tt kuppärfollukku",
  "block.minecraft.waxed_weathered_cut_copper": "Waksað weðerne´tt skurin kupär",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Waksað weðerne´tt skurin kupärstjiv",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Waksað weðerne´tt trampur åv skurin kupär",
  "block.minecraft.waxed_weathered_lightning_rod": "Vaxad väderbiten åskledare",
  "block.minecraft.weathered_chiseled_copper": "Weðerne´tt mejslað kuppär",
  "block.minecraft.weathered_copper": "Kuppärn so ir weðerbitin",
  "block.minecraft.weathered_copper_bars": "Väderbitet koppargaller",
  "block.minecraft.weathered_copper_bulb": "Weðerne´tt kuppärlampel",
  "block.minecraft.weathered_copper_chain": "Väderbiten kopparkedja",
  "block.minecraft.weathered_copper_chest": "Väderbiten kopparkista",
  "block.minecraft.weathered_copper_door": "Weðerne´tt kuppärdörr",
  "block.minecraft.weathered_copper_golem_statue": "Väderbiten koppargolemstaty",
  "block.minecraft.weathered_copper_grate": "Weðerne´tt kuppärgaller",
  "block.minecraft.weathered_copper_lantern": "Väderbiten kopparlykta",
  "block.minecraft.weathered_copper_trapdoor": "Weðerne´tt kuppärfollukku",
  "block.minecraft.weathered_cut_copper": "Weðerne´tt skurin kuppär",
  "block.minecraft.weathered_cut_copper_slab": "Wederne´tt skurin kuppärstjiv",
  "block.minecraft.weathered_cut_copper_stairs": "Weðerne´tt trampur åv skurin kuppär",
  "block.minecraft.weathered_lightning_rod": "Väderbiten åskledare",
  "block.minecraft.weeping_vines": "Druppend kleðerwekst",
  "block.minecraft.weeping_vines_plant": "Druppend kleðerwekstplemt",
  "block.minecraft.wet_sponge": "Wåt twåsopp",
  "block.minecraft.wheat": "Waitstjörd",
  "block.minecraft.white_banner": "Wait fana",
  "block.minecraft.white_bed": "Waitsaingg",
  "block.minecraft.white_candle": "Wait stiarinljuos",
  "block.minecraft.white_candle_cake": "Tårt min ljuoser i",
  "block.minecraft.white_carpet": "Wait matta",
  "block.minecraft.white_concrete": "Wait bitongg",
  "block.minecraft.white_concrete_powder": "Wait bitonggpulver",
  "block.minecraft.white_glazed_terracotta": "Waitglasirað terrakotta",
  "block.minecraft.white_shulker_box": "Wait shulkerlåða",
  "block.minecraft.white_stained_glass": "Waitflekkaðglas",
  "block.minecraft.white_stained_glass_pane": "Waitflekkaðglasrut",
  "block.minecraft.white_terracotta": "Waitt terrakotta",
  "block.minecraft.white_tulip": "Waittulpan",
  "block.minecraft.white_wool": "Wait ull",
  "block.minecraft.wildflowers": "Vildblommor",
  "block.minecraft.wither_rose": "Wissnaðruos",
  "block.minecraft.wither_skeleton_skull": "Wither bįeraunggelskoll",
  "block.minecraft.wither_skeleton_wall_skull": "Witherbįeraunggel weggskoll",
  "block.minecraft.yellow_banner": "Guol fana",
  "block.minecraft.yellow_bed": "Guol saingg",
  "block.minecraft.yellow_candle": "Guolt stiarinljuos",
  "block.minecraft.yellow_candle_cake": "Tårt min gult liuos",
  "block.minecraft.yellow_carpet": "Guol matta",
  "block.minecraft.yellow_concrete": "Guol bitongg",
  "block.minecraft.yellow_concrete_powder": "Guolt bitonggpulver",
  "block.minecraft.yellow_glazed_terracotta": "Guolglasirað terrakotta",
  "block.minecraft.yellow_shulker_box": "Guol shulkerlåða",
  "block.minecraft.yellow_stained_glass": "Guolflekkaðglas",
  "block.minecraft.yellow_stained_glass_pane": "Guolflekkaðglasrut",
  "block.minecraft.yellow_terracotta": "Guol terrakotta",
  "block.minecraft.yellow_wool": "Guol ull",
  "block.minecraft.zombie_head": "Sombiovuð",
  "block.minecraft.zombie_wall_head": "Sombiweggovuð",
  "item.minecraft.acacia_boat": "Akasiabåt",
  "item.minecraft.acacia_chest_boat": "Akasiabåt min tjistų",
  "item.minecraft.allay_spawn_egg": "Egg fer te djärå jåpsamböbökalla",
  "item.minecraft.amethyst_shard": "Ametiststjyrvel",
  "item.minecraft.angler_pottery_shard": "Keramikskärva med fiskespö",
  "item.minecraft.angler_pottery_sherd": "Keramikskärva med fiskespö",
  "item.minecraft.apple": "Eppel",
  "item.minecraft.archer_pottery_shard": "Keramikskärva med pilbåge",
  "item.minecraft.archer_pottery_sherd": "Keramikskärva med pilbåge",
  "item.minecraft.armadillo_scute": "Bältdjurshornplåt",
  "item.minecraft.armadillo_spawn_egg": "Skapelseägg för bältdjur",
  "item.minecraft.armor_stand": "Rustningsstellningg",
  "item.minecraft.arms_up_pottery_shard": "Keramikskärva med uppsträckta armar",
  "item.minecraft.arms_up_pottery_sherd": "Keramikskärva med uppsträckta armar",
  "item.minecraft.arrow": "Kuov",
  "item.minecraft.axolotl_bucket": "Įe kruk min Axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotl yndjegg",
  "item.minecraft.baked_potato": "Båkåðpära",
  "item.minecraft.bamboo_chest_raft": "Bambuflotte med kista",
  "item.minecraft.bamboo_raft": "Bambuflotte",
  "item.minecraft.bat_spawn_egg": "Egg för te djärå leðrer",
  "item.minecraft.bee_spawn_egg": "Egg fer te djärå bi minn",
  "item.minecraft.beef": "Råbiff",
  "item.minecraft.beetroot": "Roðbiet",
  "item.minecraft.beetroot_seeds": "Roðbietfrie",
  "item.minecraft.beetroot_soup": "Roðbietssuoð",
  "item.minecraft.birch_boat": "Byörkbåt",
  "item.minecraft.birch_chest_boat": "Byörkbåt min tjistų",
  "item.minecraft.black_bundle": "Svart påse",
  "item.minecraft.black_dye": "Swart ferg",
  "item.minecraft.black_harness": "Svart sele",
  "item.minecraft.blade_pottery_shard": "Keramikskärva med svärd",
  "item.minecraft.blade_pottery_sherd": "Keramikskärva med svärd",
  "item.minecraft.blaze_powder": "Flusåpuðer",
  "item.minecraft.blaze_rod": "Swigostor",
  "item.minecraft.blaze_spawn_egg": "Egg fer te djärå lugo",
  "item.minecraft.blue_bundle": "Blå påse",
  "item.minecraft.blue_dye": "Blå ferg",
  "item.minecraft.blue_egg": "Blått ägg",
  "item.minecraft.blue_harness": "Blå sele",
  "item.minecraft.bogged_spawn_egg": "Skapelseägg för sumpigt skelett",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bultförsedda rustningsdetaljer",
  "item.minecraft.bone": "Bien",
  "item.minecraft.bone_meal": "Biemyöl",
  "item.minecraft.book": "Buok",
  "item.minecraft.bordure_indented_banner_pattern": "Fanemönster för taggig ram",
  "item.minecraft.bow": "Kuovbugi",
  "item.minecraft.bowl": "Skål",
  "item.minecraft.bread": "Bröð",
  "item.minecraft.breeze_rod": "Vindstav",
  "item.minecraft.breeze_spawn_egg": "Skapelseägg för vindväsen",
  "item.minecraft.brewer_pottery_shard": "Keramikskärva med brygd",
  "item.minecraft.brewer_pottery_sherd": "Keramikskärva med brygd",
  "item.minecraft.brewing_stand": "Bryggstellningg",
  "item.minecraft.brick": "Tigelstie",
  "item.minecraft.brown_bundle": "Brun påse",
  "item.minecraft.brown_dye": "Brun ferg",
  "item.minecraft.brown_egg": "Brunt ägg",
  "item.minecraft.brown_harness": "Brun sele",
  "item.minecraft.brush": "Borste",
  "item.minecraft.bucket": "Kruka",
  "item.minecraft.bundle": "Bynde",
  "item.minecraft.bundle.empty": "Tom",
  "item.minecraft.bundle.empty.description": "Kan förvara 64 föremål av olika slag",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Keramikskärva med eldslåga",
  "item.minecraft.burn_pottery_sherd": "Keramikskärva med eldslåga",
  "item.minecraft.camel_husk_spawn_egg": "Skapelseägg för uttorkad kamel",
  "item.minecraft.camel_spawn_egg": "Skapelseägg för kamel",
  "item.minecraft.carrot": "Mųoruot",
  "item.minecraft.carrot_on_a_stick": "Mųoruot ą̊ ien pinne",
  "item.minecraft.cat_spawn_egg": "Egg fer te djärå katter",
  "item.minecraft.cauldron": "Ketil",
  "item.minecraft.cave_spider_spawn_egg": "Egg fer te djärå gråttdyörger",
  "item.minecraft.chainmail_boots": "Ringbrynsstyvler",
  "item.minecraft.chainmail_chestplate": "Ringbrynsbreststjiv",
  "item.minecraft.chainmail_helmet": "Ringbrynsjelm",
  "item.minecraft.chainmail_leggings": "Ringbrynsuosur",
  "item.minecraft.charcoal": "Träkuol",
  "item.minecraft.cherry_boat": "Körsbärsbåt",
  "item.minecraft.cherry_chest_boat": "Körsbärsbåt med kista",
  "item.minecraft.chest_minecart": "Gruvvangin min lådų",
  "item.minecraft.chicken": "Råyöna",
  "item.minecraft.chicken_spawn_egg": "Egg fer te djärå kykklingger",
  "item.minecraft.chorus_fruit": "Körfrukt",
  "item.minecraft.clay_ball": "Lierbolld",
  "item.minecraft.clock": "Klukka",
  "item.minecraft.coal": "Kuol",
  "item.minecraft.coast_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Kustutsmyckade rustningsdetaljer",
  "item.minecraft.cocoa_beans": "Soklaðbyönur",
  "item.minecraft.cod": "Rå tosk",
  "item.minecraft.cod_bucket": "Kruk min tosk",
  "item.minecraft.cod_spawn_egg": "Egg fer te djärå tosker",
  "item.minecraft.command_block_minecart": "Gruvvangin min kommandoblokk",
  "item.minecraft.compass": "Kumpass",
  "item.minecraft.cooked_beef": "Stiek",
  "item.minecraft.cooked_chicken": "Kuokaðyöna",
  "item.minecraft.cooked_cod": "Kuokað tosk",
  "item.minecraft.cooked_mutton": "Kuokaðtakktyöt",
  "item.minecraft.cooked_porkchop": "Stiekt fleskkotlett",
  "item.minecraft.cooked_rabbit": "Kuokað eri",
  "item.minecraft.cooked_salmon": "Kuokað orað",
  "item.minecraft.cookie": "Kaku",
  "item.minecraft.copper_axe": "Kopparyxa",
  "item.minecraft.copper_boots": "Kopparstövlar",
  "item.minecraft.copper_chestplate": "Kopparharnesk",
  "item.minecraft.copper_golem_spawn_egg": "Skapelseägg för koppargolem",
  "item.minecraft.copper_helmet": "Kopparhjälm",
  "item.minecraft.copper_hoe": "Kopparflåhacka",
  "item.minecraft.copper_horse_armor": "Kopparhästrustning",
  "item.minecraft.copper_ingot": "Kuppärtakk",
  "item.minecraft.copper_leggings": "Kopparbyxor",
  "item.minecraft.copper_nautilus_armor": "Kopparpärlbåtsrustning",
  "item.minecraft.copper_nugget": "Kopparklimp",
  "item.minecraft.copper_pickaxe": "Kopparhacka",
  "item.minecraft.copper_shovel": "Kopparspade",
  "item.minecraft.copper_spear": "Kopparspjut",
  "item.minecraft.copper_sword": "Kopparsvärd",
  "item.minecraft.cow_spawn_egg": "Egg fer te djärå tjyrner",
  "item.minecraft.creaking_spawn_egg": "Skapelseägg för knarrträd",
  "item.minecraft.creeper_banner_pattern": "Fanmömster",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper-leðningg",
  "item.minecraft.creeper_banner_pattern.new": "Fanemönster för creeper",
  "item.minecraft.creeper_spawn_egg": "Egg fer te djärå creeper",
  "item.minecraft.crossbow": "Armbuost",
  "item.minecraft.crossbow.projectile": "Prosjektil:",
  "item.minecraft.crossbow.projectile.multiple": "Laddade projektiler: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Laddad projektil: %s",
  "item.minecraft.cyan_bundle": "Turkos påse",
  "item.minecraft.cyan_dye": "Syan ferg",
  "item.minecraft.cyan_harness": "Turkos sele",
  "item.minecraft.danger_pottery_shard": "Keramikskärva med creeper",
  "item.minecraft.danger_pottery_sherd": "Keramikskärva med creeper",
  "item.minecraft.dark_oak_boat": "Mörkiekbåt",
  "item.minecraft.dark_oak_chest_boat": "Mörkiekbåt min tjistų",
  "item.minecraft.debug_stick": "Lausstor",
  "item.minecraft.debug_stick.empty": "%s ieg int noð",
  "item.minecraft.debug_stick.select": "weld \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "%s\" að %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantökse",
  "item.minecraft.diamond_boots": "Diamantstyvler",
  "item.minecraft.diamond_chestplate": "Diamantbreststjiv",
  "item.minecraft.diamond_helmet": "Diamantjelm",
  "item.minecraft.diamond_hoe": "Diamantflåakk",
  "item.minecraft.diamond_horse_armor": "Diamantestrustningg",
  "item.minecraft.diamond_leggings": "Diamantuosur",
  "item.minecraft.diamond_nautilus_armor": "Diamantpärlbåtsrustning",
  "item.minecraft.diamond_pickaxe": "Diamantakka",
  "item.minecraft.diamond_shovel": "Diamantreku",
  "item.minecraft.diamond_spear": "Diamantspjut",
  "item.minecraft.diamond_sword": "Diamantswärd",
  "item.minecraft.disc_fragment_5": "Stjivfragment",
  "item.minecraft.disc_fragment_5.desc": "Musikstjiv -5",
  "item.minecraft.dolphin_spawn_egg": "Egg fer te djärå delfiner",
  "item.minecraft.donkey_spawn_egg": "Egg fer te djärå åsnur",
  "item.minecraft.dragon_breath": "Drakande",
  "item.minecraft.dried_kelp": "Torkað sjugras",
  "item.minecraft.drowned_spawn_egg": "Drukknað tillwerkningsegg",
  "item.minecraft.dune_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ökenartade rustningsdetaljer",
  "item.minecraft.echo_shard": "Ekostjyrvel",
  "item.minecraft.egg": "Egg",
  "item.minecraft.elder_guardian_spawn_egg": "Egg fer te djärå gamblinggswakter",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Fertryllaðbuok",
  "item.minecraft.enchanted_golden_apple": "Fertryllað gulleppel",
  "item.minecraft.end_crystal": "Endkristall",
  "item.minecraft.ender_dragon_spawn_egg": "Skapelseägg för enderdrake",
  "item.minecraft.ender_eye": "Enderog",
  "item.minecraft.ender_pearl": "Enderpärla",
  "item.minecraft.enderman_spawn_egg": "Egg fer te djärǫ enderkall",
  "item.minecraft.endermite_spawn_egg": "Egg fer te djärå endermit",
  "item.minecraft.evoker_spawn_egg": "Egg fer te djärå evoker",
  "item.minecraft.experience_bottle": "Fertryllninggsputell",
  "item.minecraft.explorer_pottery_shard": "Keramikskärva med karta",
  "item.minecraft.explorer_pottery_sherd": "Keramikskärva med karta",
  "item.minecraft.eye_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ögondekorerade rustningsdetaljer",
  "item.minecraft.feather": "Fjäðer",
  "item.minecraft.fermented_spider_eye": "Jäst dyörgog",
  "item.minecraft.field_masoned_banner_pattern": "Fanemönster för tegelmönster",
  "item.minecraft.filled_map": "Karta",
  "item.minecraft.fire_charge": "Jäldleðningg",
  "item.minecraft.firework_rocket": "Fyrwerkeriraktiet",
  "item.minecraft.firework_rocket.flight": "Tið upi weðrę:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Fyrwerkeristienn",
  "item.minecraft.firework_star.black": "Swart",
  "item.minecraft.firework_star.blue": "Blå",
  "item.minecraft.firework_star.brown": "Brun",
  "item.minecraft.firework_star.custom_color": "Spesialgard",
  "item.minecraft.firework_star.cyan": "Syanfergað",
  "item.minecraft.firework_star.fade_to": "Blikn að",
  "item.minecraft.firework_star.flicker": "Blakka",
  "item.minecraft.firework_star.gray": "Grå",
  "item.minecraft.firework_star.green": "Gryön",
  "item.minecraft.firework_star.light_blue": "Liuosblå",
  "item.minecraft.firework_star.light_gray": "Liuosgrå",
  "item.minecraft.firework_star.lime": "Limegryön",
  "item.minecraft.firework_star.magenta": "Liuoslila",
  "item.minecraft.firework_star.orange": "Guolroð",
  "item.minecraft.firework_star.pink": "Stjär",
  "item.minecraft.firework_star.purple": "Lila",
  "item.minecraft.firework_star.red": "Roð",
  "item.minecraft.firework_star.shape": "Uokunnun form",
  "item.minecraft.firework_star.shape.burst": "Eksplusiuon",
  "item.minecraft.firework_star.shape.creeper": "Creeper-formað",
  "item.minecraft.firework_star.shape.large_ball": "Sturboll",
  "item.minecraft.firework_star.shape.small_ball": "Litn boll",
  "item.minecraft.firework_star.shape.star": "Stiennformað",
  "item.minecraft.firework_star.trail": "Spuor",
  "item.minecraft.firework_star.white": "Wait",
  "item.minecraft.firework_star.yellow": "Guol",
  "item.minecraft.fishing_rod": "Fiskspuoð",
  "item.minecraft.flint": "Flinta",
  "item.minecraft.flint_and_steel": "Jäldfyör",
  "item.minecraft.flow_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Virvelformade rustningsdetaljer",
  "item.minecraft.flow_banner_pattern": "Fanemönster",
  "item.minecraft.flow_banner_pattern.desc": "Virvel",
  "item.minecraft.flow_banner_pattern.new": "Fanemönster för virvel",
  "item.minecraft.flow_pottery_sherd": "Keramikskärva med virvel",
  "item.minecraft.flower_banner_pattern": "Fanemönster",
  "item.minecraft.flower_banner_pattern.desc": "Bliuomleðningg",
  "item.minecraft.flower_banner_pattern.new": "Fanemönster för blomma",
  "item.minecraft.flower_pot": "Bljommkruk",
  "item.minecraft.fox_spawn_egg": "Egg fer te djärå rövir",
  "item.minecraft.friend_pottery_shard": "Keramikskärva med vänligt ansikte",
  "item.minecraft.friend_pottery_sherd": "Keramikskärva med vänligt ansikte",
  "item.minecraft.frog_spawn_egg": "Tuoskrunnegg",
  "item.minecraft.furnace_minecart": "Gruvvangin min smeltungen",
  "item.minecraft.ghast_spawn_egg": "Egg fer te djärå ghast",
  "item.minecraft.ghast_tear": "Ghasttår",
  "item.minecraft.glass_bottle": "Glasputell",
  "item.minecraft.glistering_melon_slice": "Glistrend melonstjiv",
  "item.minecraft.globe_banner_pattern": "Fanmömster",
  "item.minecraft.globe_banner_pattern.desc": "Glob",
  "item.minecraft.globe_banner_pattern.new": "Fanemönster för glob",
  "item.minecraft.glow_berries": "Glyöðendber",
  "item.minecraft.glow_ink_sac": "Glyöðend bliksjäkk",
  "item.minecraft.glow_item_frame": "Glyöðend föremǫlsram",
  "item.minecraft.glow_squid_spawn_egg": "Glyöðend egg fer te djärå blikfistjin",
  "item.minecraft.glowstone_dust": "Glyöðstįedamm",
  "item.minecraft.goat_horn": "Djietuonn",
  "item.minecraft.goat_spawn_egg": "Skapelseddjer fer dijetum",
  "item.minecraft.gold_ingot": "Gulltakka",
  "item.minecraft.gold_nugget": "Gullklimp",
  "item.minecraft.golden_apple": "Gulleppel",
  "item.minecraft.golden_axe": "Gullökse",
  "item.minecraft.golden_boots": "Gullstyvler",
  "item.minecraft.golden_carrot": "Gullmųoruot",
  "item.minecraft.golden_chestplate": "Gullbreststjiv",
  "item.minecraft.golden_helmet": "Gulljelm",
  "item.minecraft.golden_hoe": "Gullflåakk",
  "item.minecraft.golden_horse_armor": "Gullestrustningg",
  "item.minecraft.golden_leggings": "Gulluosur",
  "item.minecraft.golden_nautilus_armor": "Guldpärlbåtsrustning",
  "item.minecraft.golden_pickaxe": "Gullakka",
  "item.minecraft.golden_shovel": "Gullspaði",
  "item.minecraft.golden_spear": "Guldspjut",
  "item.minecraft.golden_sword": "Gullswärd",
  "item.minecraft.gray_bundle": "Grå påse",
  "item.minecraft.gray_dye": "Grå ferg",
  "item.minecraft.gray_harness": "Grå sele",
  "item.minecraft.green_bundle": "Grön påse",
  "item.minecraft.green_dye": "Gryönferg",
  "item.minecraft.green_harness": "Grön sele",
  "item.minecraft.guardian_spawn_egg": "Egg fer te djärå wakter",
  "item.minecraft.gunpowder": "Krut",
  "item.minecraft.guster_banner_pattern": "Fanemönster",
  "item.minecraft.guster_banner_pattern.desc": "Vindväsen",
  "item.minecraft.guster_banner_pattern.new": "Fanemönster för vindväsen",
  "item.minecraft.guster_pottery_sherd": "Keramikskärva med vindväsen",
  "item.minecraft.happy_ghast_spawn_egg": "Skapelseägg för glad ghast",
  "item.minecraft.harness": "Sele",
  "item.minecraft.heart_of_the_sea": "Sjujärta",
  "item.minecraft.heart_pottery_shard": "Keramikskärva med hjärta",
  "item.minecraft.heart_pottery_sherd": "Keramikskärva med hjärta",
  "item.minecraft.heartbreak_pottery_shard": "Keramikskärva med krossat hjärta",
  "item.minecraft.heartbreak_pottery_sherd": "Keramikskärva med krossat hjärta",
  "item.minecraft.hoglin_spawn_egg": "Skapelseegg fer Hoglin",
  "item.minecraft.honey_bottle": "Onunggsputell",
  "item.minecraft.honeycomb": "Wakskaku",
  "item.minecraft.hopper_minecart": "Gruvvangin min tratt",
  "item.minecraft.horse_spawn_egg": "Egg fer te djärå ester",
  "item.minecraft.host_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.host_armor_trim_smithing_template.new": "Gästgivande rustningsdetaljer",
  "item.minecraft.howl_pottery_shard": "Keramikskärva med varg",
  "item.minecraft.howl_pottery_sherd": "Keramikskärva med varg",
  "item.minecraft.husk_spawn_egg": "Egg fer te djärå skälerer",
  "item.minecraft.ink_sac": "Blekksjäk",
  "item.minecraft.iron_axe": "Iennökse",
  "item.minecraft.iron_boots": "Iennstyvler",
  "item.minecraft.iron_chestplate": "Iennbreststjiv",
  "item.minecraft.iron_golem_spawn_egg": "Skapelseägg för järngolem",
  "item.minecraft.iron_helmet": "Iennjelm",
  "item.minecraft.iron_hoe": "Iennflåakk",
  "item.minecraft.iron_horse_armor": "Iennestrustningg",
  "item.minecraft.iron_ingot": "Ienntakka",
  "item.minecraft.iron_leggings": "Iennuosur",
  "item.minecraft.iron_nautilus_armor": "Järnpärlbåtsrustning",
  "item.minecraft.iron_nugget": "Iennkluns",
  "item.minecraft.iron_pickaxe": "Iennakka",
  "item.minecraft.iron_shovel": "Iennspaði",
  "item.minecraft.iron_spear": "Järnspjut",
  "item.minecraft.iron_sword": "Iennswärd",
  "item.minecraft.item_frame": "Ram að grejum",
  "item.minecraft.jungle_boat": "Junggelbåt",
  "item.minecraft.jungle_chest_boat": "Jungelbåt min tjistų",
  "item.minecraft.knowledge_book": "Kunnskapsbuok",
  "item.minecraft.lapis_lazuli": "Lapus lazuli",
  "item.minecraft.lava_bucket": "Lavakruk",
  "item.minecraft.lead": "Band",
  "item.minecraft.leather": "Leðer",
  "item.minecraft.leather_boots": "Leðerstyvler",
  "item.minecraft.leather_chestplate": "Leðertunika",
  "item.minecraft.leather_helmet": "Leðerett",
  "item.minecraft.leather_horse_armor": "Leðerestrustningg",
  "item.minecraft.leather_leggings": "Leðerbruok",
  "item.minecraft.light_blue_bundle": "Ljusblå påse",
  "item.minecraft.light_blue_dye": "Liuosblå ferg",
  "item.minecraft.light_blue_harness": "Ljusblå sele",
  "item.minecraft.light_gray_bundle": "Ljusgrå påse",
  "item.minecraft.light_gray_dye": "Liuosgrå ferg",
  "item.minecraft.light_gray_harness": "Ljusgrå sele",
  "item.minecraft.lime_bundle": "Limegrön påse",
  "item.minecraft.lime_dye": "Limegryön ferg",
  "item.minecraft.lime_harness": "Limegrön sele",
  "item.minecraft.lingering_potion": "Brygd så wärer laindje",
  "item.minecraft.lingering_potion.effect.awkward": "Antelin langgsam drykk",
  "item.minecraft.lingering_potion.effect.empty": "Langgsam drykk eð går it djärå",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Langgsam drykk an tuol jäldn ov",
  "item.minecraft.lingering_potion.effect.harming": "Langgsam drykk an werd skåðåð ov",
  "item.minecraft.lingering_potion.effect.healing": "Langgsam drykk an werd wildera ov",
  "item.minecraft.lingering_potion.effect.infested": "Kvardröjande infestationsbrygd",
  "item.minecraft.lingering_potion.effect.invisibility": "Langgsam drykk an werd uosynlin ov",
  "item.minecraft.lingering_potion.effect.leaping": "Langgsam drykk fer te uppa",
  "item.minecraft.lingering_potion.effect.levitation": "Langgsam drykk te fliuog min",
  "item.minecraft.lingering_potion.effect.luck": "Langgsam drykk fer lukka",
  "item.minecraft.lingering_potion.effect.mundane": "Ienkel langgsam drykk",
  "item.minecraft.lingering_potion.effect.night_vision": "Langgsam drykk an sir i mörknę minn",
  "item.minecraft.lingering_potion.effect.oozing": "Kvardröjande slemmighetsbrygd",
  "item.minecraft.lingering_potion.effect.poison": "Langgsam drykk fer te kryð ijel min",
  "item.minecraft.lingering_potion.effect.regeneration": "Langgsam drykk fer te kumå til et nyes",
  "item.minecraft.lingering_potion.effect.slow_falling": "Langgsam drykk fer te foll smått",
  "item.minecraft.lingering_potion.effect.slowness": "Langgsam drykk eð går smått ov",
  "item.minecraft.lingering_potion.effect.strength": "Langgsam drykk an werd stark ov",
  "item.minecraft.lingering_potion.effect.swiftness": "Langgsam drykk an werd snabb ov",
  "item.minecraft.lingering_potion.effect.thick": "Staðug langgsam drykk",
  "item.minecraft.lingering_potion.effect.turtle_master": "Langgsam drykk ov Stjöldkluossmiestern",
  "item.minecraft.lingering_potion.effect.water": "Langsam watuflask",
  "item.minecraft.lingering_potion.effect.water_breathing": "Langgsam drykk so an dug andes niði wattnę",
  "item.minecraft.lingering_potion.effect.weakness": "Langgsam drykk an werd wisel ov",
  "item.minecraft.lingering_potion.effect.weaving": "Kvardröjande spindelnätsbrygd",
  "item.minecraft.lingering_potion.effect.wind_charged": "Kvardröjande vindladdningsbrygd",
  "item.minecraft.llama_spawn_egg": "Egg fer te djärå lamur",
  "item.minecraft.lodestone_compass": "Magnetitkompass",
  "item.minecraft.mace": "Stridsklubba",
  "item.minecraft.magenta_bundle": "Ljuslila påse",
  "item.minecraft.magenta_dye": "Liuoslila ferg",
  "item.minecraft.magenta_harness": "Ljuslila sele",
  "item.minecraft.magma_cream": "Lavakrem",
  "item.minecraft.magma_cube_spawn_egg": "Egg fer te djärå lavakuber",
  "item.minecraft.mangrove_boat": "Mangrovebåt",
  "item.minecraft.mangrove_chest_boat": "Mangrovebåt min tjistų",
  "item.minecraft.map": "Tuomkart",
  "item.minecraft.melon_seeds": "Melonstiener",
  "item.minecraft.melon_slice": "Melonstjiv",
  "item.minecraft.milk_bucket": "Mjokkruk",
  "item.minecraft.minecart": "Gruvvangin",
  "item.minecraft.miner_pottery_shard": "Keramikskärva med hacka",
  "item.minecraft.miner_pottery_sherd": "Keramikskärva med hacka",
  "item.minecraft.mojang_banner_pattern": "Fanemönster",
  "item.minecraft.mojang_banner_pattern.desc": "Gräj",
  "item.minecraft.mojang_banner_pattern.new": "Fanemönster för mojäng",
  "item.minecraft.mooshroom_spawn_egg": "Egg fer te djärå mooshroom",
  "item.minecraft.mourner_pottery_shard": "Keramikskärva med vakt",
  "item.minecraft.mourner_pottery_sherd": "Keramikskärva med vakt",
  "item.minecraft.mule_spawn_egg": "Egg fer te djärå mulur",
  "item.minecraft.mushroom_stew": "Soppstuvningg",
  "item.minecraft.music_disc_11": "Musikstjiv",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Musikstjiv",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Musikskiva",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Musikstjiv",
  "item.minecraft.music_disc_blocks.desc": "C418 - block",
  "item.minecraft.music_disc_cat": "Musikstjiv",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Musikstjiv",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Musikskiva",
  "item.minecraft.music_disc_creator.desc": "Lena Raine – Creator",
  "item.minecraft.music_disc_creator_music_box": "Musikskiva",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine – Creator (speldosa)",
  "item.minecraft.music_disc_far": "Musikstjiv",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Musikskiva",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions – Lava Chicken",
  "item.minecraft.music_disc_mall": "Musikstjiv",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Musikstjiv",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Musikstjiv",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - oðersaiðą",
  "item.minecraft.music_disc_pigstep": "Musikskiva",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Musikskiva",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof – Precipice",
  "item.minecraft.music_disc_relic": "Musikskiva",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof – Relic",
  "item.minecraft.music_disc_stal": "Musikstjiv",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Musikstjiv",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Musikskiva",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy – Tears",
  "item.minecraft.music_disc_wait": "Musikstjiv",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Musikstjiv",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Råtakktjyöt",
  "item.minecraft.name_tag": "Namnstşylt",
  "item.minecraft.nautilus_shell": "Nautilusskal",
  "item.minecraft.nautilus_spawn_egg": "Skapelseägg för pärlbåt",
  "item.minecraft.nether_brick": "Nethertigelstie",
  "item.minecraft.nether_star": "Netherstienna",
  "item.minecraft.nether_wart": "Netherwårt",
  "item.minecraft.netherite_axe": "Netheriteöks",
  "item.minecraft.netherite_boots": "Netheritstyvler",
  "item.minecraft.netherite_chestplate": "Netheritharnesk",
  "item.minecraft.netherite_helmet": "Netheritjelm",
  "item.minecraft.netherite_hoe": "Netheriteflåakk",
  "item.minecraft.netherite_horse_armor": "Netherithästrustning",
  "item.minecraft.netherite_ingot": "Netherittakka",
  "item.minecraft.netherite_leggings": "Netheritebruok",
  "item.minecraft.netherite_nautilus_armor": "Netheritpärlbåtsrustning",
  "item.minecraft.netherite_pickaxe": "Netheriteakka",
  "item.minecraft.netherite_scrap": "Netheritskruot",
  "item.minecraft.netherite_shovel": "Netheritestjyffel",
  "item.minecraft.netherite_spear": "Netheritspjut",
  "item.minecraft.netherite_sword": "Netheriteswärd",
  "item.minecraft.netherite_upgrade_smithing_template": "Smidesmall",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherituppgradering",
  "item.minecraft.oak_boat": "Iekbåt",
  "item.minecraft.oak_chest_boat": "Iekbåt min tjistų",
  "item.minecraft.ocelot_spawn_egg": "Egg fer te djärå oceloter",
  "item.minecraft.ominous_bottle": "Oroväckande flaska",
  "item.minecraft.ominous_trial_key": "Oroväckande utmaningsnyckel",
  "item.minecraft.orange_bundle": "Orange påse",
  "item.minecraft.orange_dye": "Guolroð ferg",
  "item.minecraft.orange_harness": "Orange sele",
  "item.minecraft.painting": "Tavel",
  "item.minecraft.pale_oak_boat": "Blek ekbåt",
  "item.minecraft.pale_oak_chest_boat": "Blek ekbåt med kista",
  "item.minecraft.panda_spawn_egg": "Egg fer te djärå pandur",
  "item.minecraft.paper": "Papir",
  "item.minecraft.parched_spawn_egg": "Skapelseägg för uttorkat skelett",
  "item.minecraft.parrot_spawn_egg": "Egg fer te djärå papegojur",
  "item.minecraft.phantom_membrane": "Skromtinna",
  "item.minecraft.phantom_spawn_egg": "Egg fer te djärå spötjer",
  "item.minecraft.pig_spawn_egg": "Egg fer te djärå graiser",
  "item.minecraft.piglin_banner_pattern": "Fanemönster",
  "item.minecraft.piglin_banner_pattern.desc": "Snauta",
  "item.minecraft.piglin_banner_pattern.new": "Fanemönster för tryne",
  "item.minecraft.piglin_brute_spawn_egg": "Skapelseegg fer Piglinfugat",
  "item.minecraft.piglin_spawn_egg": "Skapelseegg fer Piglin",
  "item.minecraft.pillager_spawn_egg": "Egg fer te djärå röverer",
  "item.minecraft.pink_bundle": "Rosa påse",
  "item.minecraft.pink_dye": "Råsa ferg",
  "item.minecraft.pink_harness": "Rosa sele",
  "item.minecraft.pitcher_plant": "Kannranka",
  "item.minecraft.pitcher_pod": "Kannrankeskida",
  "item.minecraft.plenty_pottery_shard": "Keramikskärva med kista",
  "item.minecraft.plenty_pottery_sherd": "Keramikskärva med kista",
  "item.minecraft.poisonous_potato": "Djiftugpära",
  "item.minecraft.polar_bear_spawn_egg": "Egg fer te djärå aisbyönner",
  "item.minecraft.popped_chorus_fruit": "Autslaiðn körfrukt",
  "item.minecraft.porkchop": "Rå fleskkotlett",
  "item.minecraft.potato": "Pära",
  "item.minecraft.potion": "Brygd",
  "item.minecraft.potion.effect.awkward": "Avug-drykk",
  "item.minecraft.potion.effect.empty": "Drykk eð går it djärå",
  "item.minecraft.potion.effect.fire_resistance": "Drykk an tuol jäldn åv",
  "item.minecraft.potion.effect.harming": "Skåðådrykk",
  "item.minecraft.potion.effect.healing": "Drykk an limner wið ov",
  "item.minecraft.potion.effect.infested": "Infestationsbrygd",
  "item.minecraft.potion.effect.invisibility": "Drykk an werd uosynlin ov",
  "item.minecraft.potion.effect.leaping": "Drykk an upper bra ov",
  "item.minecraft.potion.effect.levitation": "Drykk fer te fliuoga",
  "item.minecraft.potion.effect.luck": "Drykk so djäv lukka",
  "item.minecraft.potion.effect.mundane": "Banal brygd",
  "item.minecraft.potion.effect.night_vision": "Drykk an sir i mörknę minn",
  "item.minecraft.potion.effect.oozing": "Slemmighetsbrygd",
  "item.minecraft.potion.effect.poison": "Kryðijeldrykk",
  "item.minecraft.potion.effect.regeneration": "Drykk fer te kumå til et nyes",
  "item.minecraft.potion.effect.slow_falling": "Drykk fer te foll smått",
  "item.minecraft.potion.effect.slowness": "Drykk eð går smått ov",
  "item.minecraft.potion.effect.strength": "Styrkedrykk",
  "item.minecraft.potion.effect.swiftness": "Drykk fer te werd snabb",
  "item.minecraft.potion.effect.thick": "Staðugdrykk",
  "item.minecraft.potion.effect.turtle_master": "Drykk fer Stjöldkluossmiestern",
  "item.minecraft.potion.effect.water": "Watuputell",
  "item.minecraft.potion.effect.water_breathing": "Drykk so an dug andes i wattnę ov",
  "item.minecraft.potion.effect.weakness": "Drykk an werd wisel ov",
  "item.minecraft.potion.effect.weaving": "Spindelnätsbrygd",
  "item.minecraft.potion.effect.wind_charged": "Vindladdningsbrygd",
  "item.minecraft.pottery_shard_archer": "Keramikskärva med pilbåge",
  "item.minecraft.pottery_shard_arms_up": "Keramikskärva med uppsträckta armar",
  "item.minecraft.pottery_shard_prize": "Keramikskärva med ädelsten",
  "item.minecraft.pottery_shard_skull": "Keramikskärva med dödskalle",
  "item.minecraft.powder_snow_bucket": "Kruk fer puðersniuon",
  "item.minecraft.prismarine_crystals": "Prismarinkristaller",
  "item.minecraft.prismarine_shard": "Prismarinstjyrvel",
  "item.minecraft.prize_pottery_shard": "Keramikskärva med ädelsten",
  "item.minecraft.prize_pottery_sherd": "Keramikskärva med ädelsten",
  "item.minecraft.pufferfish": "Puff-fisk",
  "item.minecraft.pufferfish_bucket": "Kruk min puff-fiskum",
  "item.minecraft.pufferfish_spawn_egg": "Egg fer te djärå puff-fisker",
  "item.minecraft.pumpkin_pie": "Pumpapaj",
  "item.minecraft.pumpkin_seeds": "Pumpstiener",
  "item.minecraft.purple_bundle": "Lila påse",
  "item.minecraft.purple_dye": "Lila ferg",
  "item.minecraft.purple_harness": "Lila sele",
  "item.minecraft.quartz": "Niðerkwarts",
  "item.minecraft.rabbit": "Rå eri",
  "item.minecraft.rabbit_foot": "Eråtass",
  "item.minecraft.rabbit_hide": "Eråstjinn",
  "item.minecraft.rabbit_spawn_egg": "Egg fer te djärå erir",
  "item.minecraft.rabbit_stew": "Eråstuvningg",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Uppfödande rustningsdetaljer",
  "item.minecraft.ravager_spawn_egg": "Egg fer te djärå festörerer",
  "item.minecraft.raw_copper": "Råkuppär",
  "item.minecraft.raw_gold": "Rågulleð",
  "item.minecraft.raw_iron": "Råienn",
  "item.minecraft.recovery_compass": "Tillrettend kompass",
  "item.minecraft.red_bundle": "Röd påse",
  "item.minecraft.red_dye": "Roðferg",
  "item.minecraft.red_harness": "Röd sele",
  "item.minecraft.redstone": "Redstonedamb",
  "item.minecraft.resin_brick": "Hartstegelsten",
  "item.minecraft.resin_clump": "Hartsklump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Revbensrandiga rustningsdetaljer",
  "item.minecraft.rotten_flesh": "Rotnaðflestjeð",
  "item.minecraft.saddle": "Sa’ll",
  "item.minecraft.salmon": "Rå orað",
  "item.minecraft.salmon_bucket": "Kruk min oraðum",
  "item.minecraft.salmon_spawn_egg": "Egg fer te djärå oraðir",
  "item.minecraft.scrape_pottery_sherd": "Keramikskärva med yxa",
  "item.minecraft.scute": "Skalbaiter",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Värnande rustningsdetaljer",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Formgivande rustningsdetaljer",
  "item.minecraft.sheaf_pottery_shard": "Keramikskärva med vetekärve",
  "item.minecraft.sheaf_pottery_sherd": "Keramikskärva med vetekärve",
  "item.minecraft.shears": "Saks",
  "item.minecraft.sheep_spawn_egg": "Egg fer te djärå takkur",
  "item.minecraft.shelter_pottery_shard": "Keramikskärva med träd",
  "item.minecraft.shelter_pottery_sherd": "Keramikskärva med träd",
  "item.minecraft.shield": "Stjöld",
  "item.minecraft.shield.black": "Swart stjöld",
  "item.minecraft.shield.blue": "Blå stjöld",
  "item.minecraft.shield.brown": "Brun stjöld",
  "item.minecraft.shield.cyan": "Syanfergað stjöld",
  "item.minecraft.shield.gray": "Grå stjöld",
  "item.minecraft.shield.green": "Gryön stjöld",
  "item.minecraft.shield.light_blue": "Liuosblå stjöld",
  "item.minecraft.shield.light_gray": "Liuosgrå stjöld",
  "item.minecraft.shield.lime": "Limegryön stjöld",
  "item.minecraft.shield.magenta": "Liuoslila stjöld",
  "item.minecraft.shield.orange": "Guolroð stjöld",
  "item.minecraft.shield.pink": "Stjär stjöld",
  "item.minecraft.shield.purple": "Lila stjöld",
  "item.minecraft.shield.red": "Roð stjöld",
  "item.minecraft.shield.white": "Wait stjöld",
  "item.minecraft.shield.yellow": "Guol stjöld",
  "item.minecraft.shulker_shell": "Shulkerskal",
  "item.minecraft.shulker_spawn_egg": "Egg fer te djärå shulker",
  "item.minecraft.sign": "Stjylt",
  "item.minecraft.silence_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ljudlösa rustningsdetaljer",
  "item.minecraft.silverfish_spawn_egg": "Egg fer te djärå silverfisker",
  "item.minecraft.skeleton_horse_spawn_egg": "Egg fer te djärå skelletester",
  "item.minecraft.skeleton_spawn_egg": "Egg fer te djärå skeletter",
  "item.minecraft.skull_banner_pattern": "Fanemönster",
  "item.minecraft.skull_banner_pattern.desc": "Skoll-leðningg",
  "item.minecraft.skull_banner_pattern.new": "Fanemönster för dödskalle",
  "item.minecraft.skull_pottery_shard": "Keramikskärva med dödskalle",
  "item.minecraft.skull_pottery_sherd": "Keramikskärva med dödskalle",
  "item.minecraft.slime_ball": "Kliemboll",
  "item.minecraft.slime_spawn_egg": "Egg fer te djärå kliem",
  "item.minecraft.smithing_template": "Smidesmall",
  "item.minecraft.smithing_template.applies_to": "Kan tillämpas på:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Lägg till tacka eller ädelsten",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rustningsdelar",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Lägg till rustningsdel",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Tackor och ädelstenar",
  "item.minecraft.smithing_template.ingredients": "Ingrediens(er):",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Lägg till netherittacka",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantutrustning",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Lägg till valfri typ av diamantutrustning",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherittacka",
  "item.minecraft.smithing_template.upgrade": "Uppgradering: ",
  "item.minecraft.sniffer_spawn_egg": "Skapelseägg för sniffare",
  "item.minecraft.snort_pottery_shard": "Keramikskärva med sniffare",
  "item.minecraft.snort_pottery_sherd": "Keramikskärva med sniffare",
  "item.minecraft.snout_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Trynformade rustningsdetaljer",
  "item.minecraft.snow_golem_spawn_egg": "Skapelseägg för snögolem",
  "item.minecraft.snowball": "Sniųoboll",
  "item.minecraft.spectral_arrow": "Spektralkuov",
  "item.minecraft.spider_eye": "Dyörgoga",
  "item.minecraft.spider_spawn_egg": "Egg fer te djärå dyörger",
  "item.minecraft.spire_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spiraformade rustningsdetaljer",
  "item.minecraft.splash_potion": "Skwektbrygd",
  "item.minecraft.splash_potion.effect.awkward": "Skwektend avudrykk",
  "item.minecraft.splash_potion.effect.empty": "Skwekkend drykk eð går it djärå",
  "item.minecraft.splash_potion.effect.fire_resistance": "Tweskend drykk an tuol jäldn åv",
  "item.minecraft.splash_potion.effect.harming": "Tweskend drykk an werd skåðåð ov",
  "item.minecraft.splash_potion.effect.healing": "Tweskend drykk an werd wildera ov",
  "item.minecraft.splash_potion.effect.infested": "Kastbar infestationsbrygd",
  "item.minecraft.splash_potion.effect.invisibility": "Tweskend drykk an werd uosynlin ov",
  "item.minecraft.splash_potion.effect.leaping": "Tweskend drykk an werd duktin upp ov",
  "item.minecraft.splash_potion.effect.levitation": "Tweskend drykk te fliuog min",
  "item.minecraft.splash_potion.effect.luck": "Tweskend drykk ov lukka",
  "item.minecraft.splash_potion.effect.mundane": "Skwektend ienkel drykk",
  "item.minecraft.splash_potion.effect.night_vision": "Tweskend drykk an sir i mörknę minn",
  "item.minecraft.splash_potion.effect.oozing": "Kastbar slemmighetsbrygd",
  "item.minecraft.splash_potion.effect.poison": "Tweskend drykk te kryd ijel min",
  "item.minecraft.splash_potion.effect.regeneration": "Tweskend drykk fer te kumå til et nyes",
  "item.minecraft.splash_potion.effect.slow_falling": "Tweskend drykk fer te foll smått",
  "item.minecraft.splash_potion.effect.slowness": "Tweskend drykk eð går smått ov",
  "item.minecraft.splash_potion.effect.strength": "Tweskend brygd te werd stark ov",
  "item.minecraft.splash_potion.effect.swiftness": "Tweskend rykk te werd snabb ov",
  "item.minecraft.splash_potion.effect.thick": "Skwektend digerdrykk",
  "item.minecraft.splash_potion.effect.turtle_master": "Tweskend drykk ov stjöldkluossmiestern",
  "item.minecraft.splash_potion.effect.water": "Skwektend watuflask",
  "item.minecraft.splash_potion.effect.water_breathing": "Tweskend drykk so an dug andes i wattnę ov",
  "item.minecraft.splash_potion.effect.weakness": "Tweskend drykk te werd wisel ov",
  "item.minecraft.splash_potion.effect.weaving": "Kastbar spindelnätsbrygd",
  "item.minecraft.splash_potion.effect.wind_charged": "Kastbar vindladdningsbrygd",
  "item.minecraft.spruce_boat": "Grǫbåt",
  "item.minecraft.spruce_chest_boat": "Grą̊båt min tjistų",
  "item.minecraft.spyglass": "Tjiker",
  "item.minecraft.squid_spawn_egg": "Egg fer te djärå blikfisker",
  "item.minecraft.stick": "Pinne",
  "item.minecraft.stone_axe": "Stįeökse",
  "item.minecraft.stone_hoe": "Stįeflåakk",
  "item.minecraft.stone_pickaxe": "Stįeakka",
  "item.minecraft.stone_shovel": "Stįesreku",
  "item.minecraft.stone_spear": "Stenspjut",
  "item.minecraft.stone_sword": "Stįeswärd",
  "item.minecraft.stray_spawn_egg": "Egg fer te djärå wavlerer",
  "item.minecraft.strider_spawn_egg": "Skapelseegg fer wandrer",
  "item.minecraft.string": "Tråð",
  "item.minecraft.sugar": "Sokker",
  "item.minecraft.suspicious_stew": "Misstainkt stuvningg",
  "item.minecraft.sweet_berries": "Syötu ber",
  "item.minecraft.tadpole_bucket": "Kruk min pringglur",
  "item.minecraft.tadpole_spawn_egg": "Egg fer te djäråpringglur",
  "item.minecraft.tide_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tidvattenvågsprydda rustningsdetaljer",
  "item.minecraft.tipped_arrow": "Fördjiptaðkuov",
  "item.minecraft.tipped_arrow.effect.awkward": "Fetryllað kuov",
  "item.minecraft.tipped_arrow.effect.empty": "Weltaðkuov so gor it djärå",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Kuov an tuol jäldn åv",
  "item.minecraft.tipped_arrow.effect.harming": "Kuov so skäðer",
  "item.minecraft.tipped_arrow.effect.healing": "Kuov te werd wildera ov",
  "item.minecraft.tipped_arrow.effect.infested": "Infestationspil",
  "item.minecraft.tipped_arrow.effect.invisibility": "Kuov an werd uosynlin ov",
  "item.minecraft.tipped_arrow.effect.leaping": "Kuov te upp min",
  "item.minecraft.tipped_arrow.effect.levitation": "Kuov an fliuog min",
  "item.minecraft.tipped_arrow.effect.luck": "Kuov fer lukku",
  "item.minecraft.tipped_arrow.effect.mundane": "Fetryllað kuov",
  "item.minecraft.tipped_arrow.effect.night_vision": "Kuov an sir i mörknę minn",
  "item.minecraft.tipped_arrow.effect.oozing": "Slemmighetspil",
  "item.minecraft.tipped_arrow.effect.poison": "Kuov ov drykk",
  "item.minecraft.tipped_arrow.effect.regeneration": "Kuov fer te kumå til et nyes",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Kuov fer te foll smått",
  "item.minecraft.tipped_arrow.effect.slowness": "Kuov eð går smått ov",
  "item.minecraft.tipped_arrow.effect.strength": "Styrkekuov",
  "item.minecraft.tipped_arrow.effect.swiftness": "Kuov an werd snabb ov",
  "item.minecraft.tipped_arrow.effect.thick": "Fetryllað kuov",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Kuov fer stjöldkluossmiestern",
  "item.minecraft.tipped_arrow.effect.water": "Kuov so skwekter",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Kuov fer te węs nidi wattnę",
  "item.minecraft.tipped_arrow.effect.weakness": "Wiselkuov",
  "item.minecraft.tipped_arrow.effect.weaving": "Spindelnätspil",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Vindladdningspil",
  "item.minecraft.tnt_minecart": "Gruvvanging min TNT",
  "item.minecraft.torchflower_seeds": "Fackelliljefrön",
  "item.minecraft.totem_of_undying": "Uoðoð-totem",
  "item.minecraft.trader_llama_spawn_egg": "Egg fer te djärå andelsmanlamur",
  "item.minecraft.trial_key": "Utmaningsnyckel",
  "item.minecraft.trident": "Liuoster",
  "item.minecraft.tropical_fish": "Tropisk fisk",
  "item.minecraft.tropical_fish_bucket": "Kruk min tropikfiskum",
  "item.minecraft.tropical_fish_spawn_egg": "Egg fer te djärå tropikfisker",
  "item.minecraft.turtle_helmet": "Stjöldkluossskal",
  "item.minecraft.turtle_scute": "Sköldpaddsskal",
  "item.minecraft.turtle_spawn_egg": "Egg fer te djärå stjöldkluossur",
  "item.minecraft.vex_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Osaliga rustningsdetaljer",
  "item.minecraft.vex_spawn_egg": "Egg fer te djärå biswerskupper",
  "item.minecraft.villager_spawn_egg": "Egg fer te djärå byskaller",
  "item.minecraft.vindicator_spawn_egg": "Egg fer te djärå förswarerer",
  "item.minecraft.wandering_trader_spawn_egg": "Egg fe te djärå gråer",
  "item.minecraft.ward_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Vaktande rustningsdetaljer",
  "item.minecraft.warden_spawn_egg": "Egg fer te djärå wakter",
  "item.minecraft.warped_fungus_on_a_stick": "Fevrenggd sopp ǫ ienum pinne",
  "item.minecraft.water_bucket": "Wattukruk",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Vägvisande rustningsdetaljer",
  "item.minecraft.wheat": "Waita",
  "item.minecraft.wheat_seeds": "Waitkuonn",
  "item.minecraft.white_bundle": "Vit påse",
  "item.minecraft.white_dye": "Wait ferg",
  "item.minecraft.white_harness": "Vit sele",
  "item.minecraft.wild_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Vildsinta rustningsdetaljer",
  "item.minecraft.wind_charge": "Vindladdning",
  "item.minecraft.witch_spawn_egg": "Egg fer te djärå eksur",
  "item.minecraft.wither_skeleton_spawn_egg": "Egg fer te djärå witherbįeraunggel",
  "item.minecraft.wither_spawn_egg": "Skapelseägg för Wither",
  "item.minecraft.wolf_armor": "Vargrustning",
  "item.minecraft.wolf_spawn_egg": "Egg fer te djärå warger",
  "item.minecraft.wooden_axe": "Wiðåöks",
  "item.minecraft.wooden_hoe": "Wiðåflåakk",
  "item.minecraft.wooden_pickaxe": "Wiðåakka",
  "item.minecraft.wooden_shovel": "Wiðåspaði",
  "item.minecraft.wooden_spear": "Träspjut",
  "item.minecraft.wooden_sword": "Wiðåswärd",
  "item.minecraft.writable_book": "Buok og fjäðerpenn",
  "item.minecraft.written_book": "Skrievað buok",
  "item.minecraft.yellow_bundle": "Gul påse",
  "item.minecraft.yellow_dye": "Guol ferg",
  "item.minecraft.yellow_harness": "Gul sele",
  "item.minecraft.zoglin_spawn_egg": "Skapelseegg fer Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Egg fer te djärå sombiester",
  "item.minecraft.zombie_nautilus_spawn_egg": "Skapelseägg för zombiepärlbåt",
  "item.minecraft.zombie_spawn_egg": "Egg fer te djärå sombier",
  "item.minecraft.zombie_villager_spawn_egg": "Egg fer te djärå sombibyskaller",
  "item.minecraft.zombified_piglin_spawn_egg": "Skapelseegg fer sombifiirað Piglin"
}
export const ovd = items; 
